/*
 * unicode.ts
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT license.
 *
 * Tables that encode Unicode character codes for various Unicode-
 * defined categories used in the Python spec.
 *
 * Generated by build/generateUnicodeTables.py from the UnicodeData.txt
 * metadata file for Unicode 16.0.
 */

export type UnicodeRange = [number, number] | number;
export type UnicodeRangeTable = UnicodeRange[];
export type UnicodeSurrogateRangeTable = { [surrogate: number]: UnicodeRange[] };

export const unicodeLu: UnicodeRangeTable = [
    [0x0041, 0x005a],
    [0x00c0, 0x00d6],
    [0x00d8, 0x00de],
    0x0100,
    0x0102,
    0x0104,
    0x0106,
    0x0108,
    0x010a,
    0x010c,
    0x010e,
    0x0110,
    0x0112,
    0x0114,
    0x0116,
    0x0118,
    0x011a,
    0x011c,
    0x011e,
    0x0120,
    0x0122,
    0x0124,
    0x0126,
    0x0128,
    0x012a,
    0x012c,
    0x012e,
    0x0130,
    0x0132,
    0x0134,
    0x0136,
    0x0139,
    0x013b,
    0x013d,
    0x013f,
    0x0141,
    0x0143,
    0x0145,
    0x0147,
    0x014a,
    0x014c,
    0x014e,
    0x0150,
    0x0152,
    0x0154,
    0x0156,
    0x0158,
    0x015a,
    0x015c,
    0x015e,
    0x0160,
    0x0162,
    0x0164,
    0x0166,
    0x0168,
    0x016a,
    0x016c,
    0x016e,
    0x0170,
    0x0172,
    0x0174,
    0x0176,
    [0x0178, 0x0179],
    0x017b,
    0x017d,
    [0x0181, 0x0182],
    0x0184,
    [0x0186, 0x0187],
    [0x0189, 0x018b],
    [0x018e, 0x0191],
    [0x0193, 0x0194],
    [0x0196, 0x0198],
    [0x019c, 0x019d],
    [0x019f, 0x01a0],
    0x01a2,
    0x01a4,
    [0x01a6, 0x01a7],
    0x01a9,
    0x01ac,
    [0x01ae, 0x01af],
    [0x01b1, 0x01b3],
    0x01b5,
    [0x01b7, 0x01b8],
    0x01bc,
    0x01c4,
    0x01c7,
    0x01ca,
    0x01cd,
    0x01cf,
    0x01d1,
    0x01d3,
    0x01d5,
    0x01d7,
    0x01d9,
    0x01db,
    0x01de,
    0x01e0,
    0x01e2,
    0x01e4,
    0x01e6,
    0x01e8,
    0x01ea,
    0x01ec,
    0x01ee,
    0x01f1,
    0x01f4,
    [0x01f6, 0x01f8],
    0x01fa,
    0x01fc,
    0x01fe,
    0x0200,
    0x0202,
    0x0204,
    0x0206,
    0x0208,
    0x020a,
    0x020c,
    0x020e,
    0x0210,
    0x0212,
    0x0214,
    0x0216,
    0x0218,
    0x021a,
    0x021c,
    0x021e,
    0x0220,
    0x0222,
    0x0224,
    0x0226,
    0x0228,
    0x022a,
    0x022c,
    0x022e,
    0x0230,
    0x0232,
    [0x023a, 0x023b],
    [0x023d, 0x023e],
    0x0241,
    [0x0243, 0x0246],
    0x0248,
    0x024a,
    0x024c,
    0x024e,
    0x0370,
    0x0372,
    0x0376,
    0x037f,
    0x0386,
    [0x0388, 0x038a],
    0x038c,
    [0x038e, 0x038f],
    [0x0391, 0x03a1],
    [0x03a3, 0x03ab],
    0x03cf,
    [0x03d2, 0x03d4],
    0x03d8,
    0x03da,
    0x03dc,
    0x03de,
    0x03e0,
    0x03e2,
    0x03e4,
    0x03e6,
    0x03e8,
    0x03ea,
    0x03ec,
    0x03ee,
    0x03f4,
    0x03f7,
    [0x03f9, 0x03fa],
    [0x03fd, 0x042f],
    0x0460,
    0x0462,
    0x0464,
    0x0466,
    0x0468,
    0x046a,
    0x046c,
    0x046e,
    0x0470,
    0x0472,
    0x0474,
    0x0476,
    0x0478,
    0x047a,
    0x047c,
    0x047e,
    0x0480,
    0x048a,
    0x048c,
    0x048e,
    0x0490,
    0x0492,
    0x0494,
    0x0496,
    0x0498,
    0x049a,
    0x049c,
    0x049e,
    0x04a0,
    0x04a2,
    0x04a4,
    0x04a6,
    0x04a8,
    0x04aa,
    0x04ac,
    0x04ae,
    0x04b0,
    0x04b2,
    0x04b4,
    0x04b6,
    0x04b8,
    0x04ba,
    0x04bc,
    0x04be,
    [0x04c0, 0x04c1],
    0x04c3,
    0x04c5,
    0x04c7,
    0x04c9,
    0x04cb,
    0x04cd,
    0x04d0,
    0x04d2,
    0x04d4,
    0x04d6,
    0x04d8,
    0x04da,
    0x04dc,
    0x04de,
    0x04e0,
    0x04e2,
    0x04e4,
    0x04e6,
    0x04e8,
    0x04ea,
    0x04ec,
    0x04ee,
    0x04f0,
    0x04f2,
    0x04f4,
    0x04f6,
    0x04f8,
    0x04fa,
    0x04fc,
    0x04fe,
    0x0500,
    0x0502,
    0x0504,
    0x0506,
    0x0508,
    0x050a,
    0x050c,
    0x050e,
    0x0510,
    0x0512,
    0x0514,
    0x0516,
    0x0518,
    0x051a,
    0x051c,
    0x051e,
    0x0520,
    0x0522,
    0x0524,
    0x0526,
    0x0528,
    0x052a,
    0x052c,
    0x052e,
    [0x0531, 0x0556],
    [0x10a0, 0x10c5],
    0x10c7,
    0x10cd,
    [0x13a0, 0x13f5],
    0x1c89,
    [0x1c90, 0x1cba],
    [0x1cbd, 0x1cbf],
    0x1e00,
    0x1e02,
    0x1e04,
    0x1e06,
    0x1e08,
    0x1e0a,
    0x1e0c,
    0x1e0e,
    0x1e10,
    0x1e12,
    0x1e14,
    0x1e16,
    0x1e18,
    0x1e1a,
    0x1e1c,
    0x1e1e,
    0x1e20,
    0x1e22,
    0x1e24,
    0x1e26,
    0x1e28,
    0x1e2a,
    0x1e2c,
    0x1e2e,
    0x1e30,
    0x1e32,
    0x1e34,
    0x1e36,
    0x1e38,
    0x1e3a,
    0x1e3c,
    0x1e3e,
    0x1e40,
    0x1e42,
    0x1e44,
    0x1e46,
    0x1e48,
    0x1e4a,
    0x1e4c,
    0x1e4e,
    0x1e50,
    0x1e52,
    0x1e54,
    0x1e56,
    0x1e58,
    0x1e5a,
    0x1e5c,
    0x1e5e,
    0x1e60,
    0x1e62,
    0x1e64,
    0x1e66,
    0x1e68,
    0x1e6a,
    0x1e6c,
    0x1e6e,
    0x1e70,
    0x1e72,
    0x1e74,
    0x1e76,
    0x1e78,
    0x1e7a,
    0x1e7c,
    0x1e7e,
    0x1e80,
    0x1e82,
    0x1e84,
    0x1e86,
    0x1e88,
    0x1e8a,
    0x1e8c,
    0x1e8e,
    0x1e90,
    0x1e92,
    0x1e94,
    0x1e9e,
    0x1ea0,
    0x1ea2,
    0x1ea4,
    0x1ea6,
    0x1ea8,
    0x1eaa,
    0x1eac,
    0x1eae,
    0x1eb0,
    0x1eb2,
    0x1eb4,
    0x1eb6,
    0x1eb8,
    0x1eba,
    0x1ebc,
    0x1ebe,
    0x1ec0,
    0x1ec2,
    0x1ec4,
    0x1ec6,
    0x1ec8,
    0x1eca,
    0x1ecc,
    0x1ece,
    0x1ed0,
    0x1ed2,
    0x1ed4,
    0x1ed6,
    0x1ed8,
    0x1eda,
    0x1edc,
    0x1ede,
    0x1ee0,
    0x1ee2,
    0x1ee4,
    0x1ee6,
    0x1ee8,
    0x1eea,
    0x1eec,
    0x1eee,
    0x1ef0,
    0x1ef2,
    0x1ef4,
    0x1ef6,
    0x1ef8,
    0x1efa,
    0x1efc,
    0x1efe,
    [0x1f08, 0x1f0f],
    [0x1f18, 0x1f1d],
    [0x1f28, 0x1f2f],
    [0x1f38, 0x1f3f],
    [0x1f48, 0x1f4d],
    0x1f59,
    0x1f5b,
    0x1f5d,
    0x1f5f,
    [0x1f68, 0x1f6f],
    [0x1fb8, 0x1fbb],
    [0x1fc8, 0x1fcb],
    [0x1fd8, 0x1fdb],
    [0x1fe8, 0x1fec],
    [0x1ff8, 0x1ffb],
    0x2102,
    0x2107,
    [0x210b, 0x210d],
    [0x2110, 0x2112],
    0x2115,
    [0x2119, 0x211d],
    0x2124,
    0x2126,
    0x2128,
    [0x212a, 0x212d],
    [0x2130, 0x2133],
    [0x213e, 0x213f],
    0x2145,
    0x2183,
    [0x2c00, 0x2c2f],
    0x2c60,
    [0x2c62, 0x2c64],
    0x2c67,
    0x2c69,
    0x2c6b,
    [0x2c6d, 0x2c70],
    0x2c72,
    0x2c75,
    [0x2c7e, 0x2c80],
    0x2c82,
    0x2c84,
    0x2c86,
    0x2c88,
    0x2c8a,
    0x2c8c,
    0x2c8e,
    0x2c90,
    0x2c92,
    0x2c94,
    0x2c96,
    0x2c98,
    0x2c9a,
    0x2c9c,
    0x2c9e,
    0x2ca0,
    0x2ca2,
    0x2ca4,
    0x2ca6,
    0x2ca8,
    0x2caa,
    0x2cac,
    0x2cae,
    0x2cb0,
    0x2cb2,
    0x2cb4,
    0x2cb6,
    0x2cb8,
    0x2cba,
    0x2cbc,
    0x2cbe,
    0x2cc0,
    0x2cc2,
    0x2cc4,
    0x2cc6,
    0x2cc8,
    0x2cca,
    0x2ccc,
    0x2cce,
    0x2cd0,
    0x2cd2,
    0x2cd4,
    0x2cd6,
    0x2cd8,
    0x2cda,
    0x2cdc,
    0x2cde,
    0x2ce0,
    0x2ce2,
    0x2ceb,
    0x2ced,
    0x2cf2,
    0xa640,
    0xa642,
    0xa644,
    0xa646,
    0xa648,
    0xa64a,
    0xa64c,
    0xa64e,
    0xa650,
    0xa652,
    0xa654,
    0xa656,
    0xa658,
    0xa65a,
    0xa65c,
    0xa65e,
    0xa660,
    0xa662,
    0xa664,
    0xa666,
    0xa668,
    0xa66a,
    0xa66c,
    0xa680,
    0xa682,
    0xa684,
    0xa686,
    0xa688,
    0xa68a,
    0xa68c,
    0xa68e,
    0xa690,
    0xa692,
    0xa694,
    0xa696,
    0xa698,
    0xa69a,
    0xa722,
    0xa724,
    0xa726,
    0xa728,
    0xa72a,
    0xa72c,
    0xa72e,
    0xa732,
    0xa734,
    0xa736,
    0xa738,
    0xa73a,
    0xa73c,
    0xa73e,
    0xa740,
    0xa742,
    0xa744,
    0xa746,
    0xa748,
    0xa74a,
    0xa74c,
    0xa74e,
    0xa750,
    0xa752,
    0xa754,
    0xa756,
    0xa758,
    0xa75a,
    0xa75c,
    0xa75e,
    0xa760,
    0xa762,
    0xa764,
    0xa766,
    0xa768,
    0xa76a,
    0xa76c,
    0xa76e,
    0xa779,
    0xa77b,
    [0xa77d, 0xa77e],
    0xa780,
    0xa782,
    0xa784,
    0xa786,
    0xa78b,
    0xa78d,
    0xa790,
    0xa792,
    0xa796,
    0xa798,
    0xa79a,
    0xa79c,
    0xa79e,
    0xa7a0,
    0xa7a2,
    0xa7a4,
    0xa7a6,
    0xa7a8,
    [0xa7aa, 0xa7ae],
    [0xa7b0, 0xa7b4],
    0xa7b6,
    0xa7b8,
    0xa7ba,
    0xa7bc,
    0xa7be,
    0xa7c0,
    0xa7c2,
    [0xa7c4, 0xa7c7],
    0xa7c9,
    [0xa7cb, 0xa7cc],
    0xa7d0,
    0xa7d6,
    0xa7d8,
    0xa7da,
    0xa7dc,
    0xa7f5,
    [0xff21, 0xff3a],
    [0x10400, 0x10427],
    [0x104b0, 0x104d3],
    [0x10570, 0x1057a],
    [0x1057c, 0x1058a],
    [0x1058c, 0x10592],
    [0x10594, 0x10595],
    [0x10c80, 0x10cb2],
    [0x10d50, 0x10d65],
    [0x118a0, 0x118bf],
    [0x16e40, 0x16e5f],
    [0x1d400, 0x1d419],
    [0x1d434, 0x1d44d],
    [0x1d468, 0x1d481],
    0x1d49c,
    [0x1d49e, 0x1d49f],
    0x1d4a2,
    [0x1d4a5, 0x1d4a6],
    [0x1d4a9, 0x1d4ac],
    [0x1d4ae, 0x1d4b5],
    [0x1d4d0, 0x1d4e9],
    [0x1d504, 0x1d505],
    [0x1d507, 0x1d50a],
    [0x1d50d, 0x1d514],
    [0x1d516, 0x1d51c],
    [0x1d538, 0x1d539],
    [0x1d53b, 0x1d53e],
    [0x1d540, 0x1d544],
    0x1d546,
    [0x1d54a, 0x1d550],
    [0x1d56c, 0x1d585],
    [0x1d5a0, 0x1d5b9],
    [0x1d5d4, 0x1d5ed],
    [0x1d608, 0x1d621],
    [0x1d63c, 0x1d655],
    [0x1d670, 0x1d689],
    [0x1d6a8, 0x1d6c0],
    [0x1d6e2, 0x1d6fa],
    [0x1d71c, 0x1d734],
    [0x1d756, 0x1d76e],
    [0x1d790, 0x1d7a8],
    0x1d7ca,
    [0x1e900, 0x1e921],
];

export const unicodeLuSurrogate: UnicodeSurrogateRangeTable = {
    0xd801: [
        [0xdc00, 0xdc27], // 0x10400..0x10427
        [0xdcb0, 0xdcd3], // 0x104B0..0x104D3
        [0xdd70, 0xdd7a], // 0x10570..0x1057A
        [0xdd7c, 0xdd8a], // 0x1057C..0x1058A
        [0xdd8c, 0xdd92], // 0x1058C..0x10592
        [0xdd94, 0xdd95], // 0x10594..0x10595
    ],
    0xd803: [
        [0xdc80, 0xdcb2], // 0x10C80..0x10CB2
        [0xdd50, 0xdd65], // 0x10D50..0x10D65
    ],
    0xd806: [
        [0xdca0, 0xdcbf], // 0x118A0..0x118BF
    ],
    0xd81b: [
        [0xde40, 0xde5f], // 0x16E40..0x16E5F
    ],
    0xd835: [
        [0xdc00, 0xdc19], // 0x1D400..0x1D419
        [0xdc34, 0xdc4d], // 0x1D434..0x1D44D
        [0xdc68, 0xdc81], // 0x1D468..0x1D481
        0xdc9c, // 0x1D49C
        [0xdc9e, 0xdc9f], // 0x1D49E..0x1D49F
        0xdca2, // 0x1D4A2
        [0xdca5, 0xdca6], // 0x1D4A5..0x1D4A6
        [0xdca9, 0xdcac], // 0x1D4A9..0x1D4AC
        [0xdcae, 0xdcb5], // 0x1D4AE..0x1D4B5
        [0xdcd0, 0xdce9], // 0x1D4D0..0x1D4E9
        [0xdd04, 0xdd05], // 0x1D504..0x1D505
        [0xdd07, 0xdd0a], // 0x1D507..0x1D50A
        [0xdd0d, 0xdd14], // 0x1D50D..0x1D514
        [0xdd16, 0xdd1c], // 0x1D516..0x1D51C
        [0xdd38, 0xdd39], // 0x1D538..0x1D539
        [0xdd3b, 0xdd3e], // 0x1D53B..0x1D53E
        [0xdd40, 0xdd44], // 0x1D540..0x1D544
        0xdd46, // 0x1D546
        [0xdd4a, 0xdd50], // 0x1D54A..0x1D550
        [0xdd6c, 0xdd85], // 0x1D56C..0x1D585
        [0xdda0, 0xddb9], // 0x1D5A0..0x1D5B9
        [0xddd4, 0xdded], // 0x1D5D4..0x1D5ED
        [0xde08, 0xde21], // 0x1D608..0x1D621
        [0xde3c, 0xde55], // 0x1D63C..0x1D655
        [0xde70, 0xde89], // 0x1D670..0x1D689
        [0xdea8, 0xdec0], // 0x1D6A8..0x1D6C0
        [0xdee2, 0xdefa], // 0x1D6E2..0x1D6FA
        [0xdf1c, 0xdf34], // 0x1D71C..0x1D734
        [0xdf56, 0xdf6e], // 0x1D756..0x1D76E
        [0xdf90, 0xdfa8], // 0x1D790..0x1D7A8
        0xdfca, // 0x1D7CA
    ],
    0xd83a: [
        [0xdd00, 0xdd21], // 0x1E900..0x1E921
    ],
};

export const unicodeLl: UnicodeRangeTable = [
    [0x0061, 0x007a],
    0x00b5,
    [0x00df, 0x00f6],
    [0x00f8, 0x00ff],
    0x0101,
    0x0103,
    0x0105,
    0x0107,
    0x0109,
    0x010b,
    0x010d,
    0x010f,
    0x0111,
    0x0113,
    0x0115,
    0x0117,
    0x0119,
    0x011b,
    0x011d,
    0x011f,
    0x0121,
    0x0123,
    0x0125,
    0x0127,
    0x0129,
    0x012b,
    0x012d,
    0x012f,
    0x0131,
    0x0133,
    0x0135,
    [0x0137, 0x0138],
    0x013a,
    0x013c,
    0x013e,
    0x0140,
    0x0142,
    0x0144,
    0x0146,
    [0x0148, 0x0149],
    0x014b,
    0x014d,
    0x014f,
    0x0151,
    0x0153,
    0x0155,
    0x0157,
    0x0159,
    0x015b,
    0x015d,
    0x015f,
    0x0161,
    0x0163,
    0x0165,
    0x0167,
    0x0169,
    0x016b,
    0x016d,
    0x016f,
    0x0171,
    0x0173,
    0x0175,
    0x0177,
    0x017a,
    0x017c,
    [0x017e, 0x0180],
    0x0183,
    0x0185,
    0x0188,
    [0x018c, 0x018d],
    0x0192,
    0x0195,
    [0x0199, 0x019b],
    0x019e,
    0x01a1,
    0x01a3,
    0x01a5,
    0x01a8,
    [0x01aa, 0x01ab],
    0x01ad,
    0x01b0,
    0x01b4,
    0x01b6,
    [0x01b9, 0x01ba],
    [0x01bd, 0x01bf],
    0x01c6,
    0x01c9,
    0x01cc,
    0x01ce,
    0x01d0,
    0x01d2,
    0x01d4,
    0x01d6,
    0x01d8,
    0x01da,
    [0x01dc, 0x01dd],
    0x01df,
    0x01e1,
    0x01e3,
    0x01e5,
    0x01e7,
    0x01e9,
    0x01eb,
    0x01ed,
    [0x01ef, 0x01f0],
    0x01f3,
    0x01f5,
    0x01f9,
    0x01fb,
    0x01fd,
    0x01ff,
    0x0201,
    0x0203,
    0x0205,
    0x0207,
    0x0209,
    0x020b,
    0x020d,
    0x020f,
    0x0211,
    0x0213,
    0x0215,
    0x0217,
    0x0219,
    0x021b,
    0x021d,
    0x021f,
    0x0221,
    0x0223,
    0x0225,
    0x0227,
    0x0229,
    0x022b,
    0x022d,
    0x022f,
    0x0231,
    [0x0233, 0x0239],
    0x023c,
    [0x023f, 0x0240],
    0x0242,
    0x0247,
    0x0249,
    0x024b,
    0x024d,
    [0x024f, 0x0293],
    [0x0295, 0x02af],
    0x0371,
    0x0373,
    0x0377,
    [0x037b, 0x037d],
    0x0390,
    [0x03ac, 0x03ce],
    [0x03d0, 0x03d1],
    [0x03d5, 0x03d7],
    0x03d9,
    0x03db,
    0x03dd,
    0x03df,
    0x03e1,
    0x03e3,
    0x03e5,
    0x03e7,
    0x03e9,
    0x03eb,
    0x03ed,
    [0x03ef, 0x03f3],
    0x03f5,
    0x03f8,
    [0x03fb, 0x03fc],
    [0x0430, 0x045f],
    0x0461,
    0x0463,
    0x0465,
    0x0467,
    0x0469,
    0x046b,
    0x046d,
    0x046f,
    0x0471,
    0x0473,
    0x0475,
    0x0477,
    0x0479,
    0x047b,
    0x047d,
    0x047f,
    0x0481,
    0x048b,
    0x048d,
    0x048f,
    0x0491,
    0x0493,
    0x0495,
    0x0497,
    0x0499,
    0x049b,
    0x049d,
    0x049f,
    0x04a1,
    0x04a3,
    0x04a5,
    0x04a7,
    0x04a9,
    0x04ab,
    0x04ad,
    0x04af,
    0x04b1,
    0x04b3,
    0x04b5,
    0x04b7,
    0x04b9,
    0x04bb,
    0x04bd,
    0x04bf,
    0x04c2,
    0x04c4,
    0x04c6,
    0x04c8,
    0x04ca,
    0x04cc,
    [0x04ce, 0x04cf],
    0x04d1,
    0x04d3,
    0x04d5,
    0x04d7,
    0x04d9,
    0x04db,
    0x04dd,
    0x04df,
    0x04e1,
    0x04e3,
    0x04e5,
    0x04e7,
    0x04e9,
    0x04eb,
    0x04ed,
    0x04ef,
    0x04f1,
    0x04f3,
    0x04f5,
    0x04f7,
    0x04f9,
    0x04fb,
    0x04fd,
    0x04ff,
    0x0501,
    0x0503,
    0x0505,
    0x0507,
    0x0509,
    0x050b,
    0x050d,
    0x050f,
    0x0511,
    0x0513,
    0x0515,
    0x0517,
    0x0519,
    0x051b,
    0x051d,
    0x051f,
    0x0521,
    0x0523,
    0x0525,
    0x0527,
    0x0529,
    0x052b,
    0x052d,
    0x052f,
    [0x0560, 0x0588],
    [0x10d0, 0x10fa],
    [0x10fd, 0x10ff],
    [0x13f8, 0x13fd],
    [0x1c80, 0x1c88],
    0x1c8a,
    [0x1d00, 0x1d2b],
    [0x1d6b, 0x1d77],
    [0x1d79, 0x1d9a],
    0x1e01,
    0x1e03,
    0x1e05,
    0x1e07,
    0x1e09,
    0x1e0b,
    0x1e0d,
    0x1e0f,
    0x1e11,
    0x1e13,
    0x1e15,
    0x1e17,
    0x1e19,
    0x1e1b,
    0x1e1d,
    0x1e1f,
    0x1e21,
    0x1e23,
    0x1e25,
    0x1e27,
    0x1e29,
    0x1e2b,
    0x1e2d,
    0x1e2f,
    0x1e31,
    0x1e33,
    0x1e35,
    0x1e37,
    0x1e39,
    0x1e3b,
    0x1e3d,
    0x1e3f,
    0x1e41,
    0x1e43,
    0x1e45,
    0x1e47,
    0x1e49,
    0x1e4b,
    0x1e4d,
    0x1e4f,
    0x1e51,
    0x1e53,
    0x1e55,
    0x1e57,
    0x1e59,
    0x1e5b,
    0x1e5d,
    0x1e5f,
    0x1e61,
    0x1e63,
    0x1e65,
    0x1e67,
    0x1e69,
    0x1e6b,
    0x1e6d,
    0x1e6f,
    0x1e71,
    0x1e73,
    0x1e75,
    0x1e77,
    0x1e79,
    0x1e7b,
    0x1e7d,
    0x1e7f,
    0x1e81,
    0x1e83,
    0x1e85,
    0x1e87,
    0x1e89,
    0x1e8b,
    0x1e8d,
    0x1e8f,
    0x1e91,
    0x1e93,
    [0x1e95, 0x1e9d],
    0x1e9f,
    0x1ea1,
    0x1ea3,
    0x1ea5,
    0x1ea7,
    0x1ea9,
    0x1eab,
    0x1ead,
    0x1eaf,
    0x1eb1,
    0x1eb3,
    0x1eb5,
    0x1eb7,
    0x1eb9,
    0x1ebb,
    0x1ebd,
    0x1ebf,
    0x1ec1,
    0x1ec3,
    0x1ec5,
    0x1ec7,
    0x1ec9,
    0x1ecb,
    0x1ecd,
    0x1ecf,
    0x1ed1,
    0x1ed3,
    0x1ed5,
    0x1ed7,
    0x1ed9,
    0x1edb,
    0x1edd,
    0x1edf,
    0x1ee1,
    0x1ee3,
    0x1ee5,
    0x1ee7,
    0x1ee9,
    0x1eeb,
    0x1eed,
    0x1eef,
    0x1ef1,
    0x1ef3,
    0x1ef5,
    0x1ef7,
    0x1ef9,
    0x1efb,
    0x1efd,
    [0x1eff, 0x1f07],
    [0x1f10, 0x1f15],
    [0x1f20, 0x1f27],
    [0x1f30, 0x1f37],
    [0x1f40, 0x1f45],
    [0x1f50, 0x1f57],
    [0x1f60, 0x1f67],
    [0x1f70, 0x1f7d],
    [0x1f80, 0x1f87],
    [0x1f90, 0x1f97],
    [0x1fa0, 0x1fa7],
    [0x1fb0, 0x1fb4],
    [0x1fb6, 0x1fb7],
    0x1fbe,
    [0x1fc2, 0x1fc4],
    [0x1fc6, 0x1fc7],
    [0x1fd0, 0x1fd3],
    [0x1fd6, 0x1fd7],
    [0x1fe0, 0x1fe7],
    [0x1ff2, 0x1ff4],
    [0x1ff6, 0x1ff7],
    0x210a,
    [0x210e, 0x210f],
    0x2113,
    0x212f,
    0x2134,
    0x2139,
    [0x213c, 0x213d],
    [0x2146, 0x2149],
    0x214e,
    0x2184,
    [0x2c30, 0x2c5f],
    0x2c61,
    [0x2c65, 0x2c66],
    0x2c68,
    0x2c6a,
    0x2c6c,
    0x2c71,
    [0x2c73, 0x2c74],
    [0x2c76, 0x2c7b],
    0x2c81,
    0x2c83,
    0x2c85,
    0x2c87,
    0x2c89,
    0x2c8b,
    0x2c8d,
    0x2c8f,
    0x2c91,
    0x2c93,
    0x2c95,
    0x2c97,
    0x2c99,
    0x2c9b,
    0x2c9d,
    0x2c9f,
    0x2ca1,
    0x2ca3,
    0x2ca5,
    0x2ca7,
    0x2ca9,
    0x2cab,
    0x2cad,
    0x2caf,
    0x2cb1,
    0x2cb3,
    0x2cb5,
    0x2cb7,
    0x2cb9,
    0x2cbb,
    0x2cbd,
    0x2cbf,
    0x2cc1,
    0x2cc3,
    0x2cc5,
    0x2cc7,
    0x2cc9,
    0x2ccb,
    0x2ccd,
    0x2ccf,
    0x2cd1,
    0x2cd3,
    0x2cd5,
    0x2cd7,
    0x2cd9,
    0x2cdb,
    0x2cdd,
    0x2cdf,
    0x2ce1,
    [0x2ce3, 0x2ce4],
    0x2cec,
    0x2cee,
    0x2cf3,
    [0x2d00, 0x2d25],
    0x2d27,
    0x2d2d,
    0xa641,
    0xa643,
    0xa645,
    0xa647,
    0xa649,
    0xa64b,
    0xa64d,
    0xa64f,
    0xa651,
    0xa653,
    0xa655,
    0xa657,
    0xa659,
    0xa65b,
    0xa65d,
    0xa65f,
    0xa661,
    0xa663,
    0xa665,
    0xa667,
    0xa669,
    0xa66b,
    0xa66d,
    0xa681,
    0xa683,
    0xa685,
    0xa687,
    0xa689,
    0xa68b,
    0xa68d,
    0xa68f,
    0xa691,
    0xa693,
    0xa695,
    0xa697,
    0xa699,
    0xa69b,
    0xa723,
    0xa725,
    0xa727,
    0xa729,
    0xa72b,
    0xa72d,
    [0xa72f, 0xa731],
    0xa733,
    0xa735,
    0xa737,
    0xa739,
    0xa73b,
    0xa73d,
    0xa73f,
    0xa741,
    0xa743,
    0xa745,
    0xa747,
    0xa749,
    0xa74b,
    0xa74d,
    0xa74f,
    0xa751,
    0xa753,
    0xa755,
    0xa757,
    0xa759,
    0xa75b,
    0xa75d,
    0xa75f,
    0xa761,
    0xa763,
    0xa765,
    0xa767,
    0xa769,
    0xa76b,
    0xa76d,
    0xa76f,
    [0xa771, 0xa778],
    0xa77a,
    0xa77c,
    0xa77f,
    0xa781,
    0xa783,
    0xa785,
    0xa787,
    0xa78c,
    0xa78e,
    0xa791,
    [0xa793, 0xa795],
    0xa797,
    0xa799,
    0xa79b,
    0xa79d,
    0xa79f,
    0xa7a1,
    0xa7a3,
    0xa7a5,
    0xa7a7,
    0xa7a9,
    0xa7af,
    0xa7b5,
    0xa7b7,
    0xa7b9,
    0xa7bb,
    0xa7bd,
    0xa7bf,
    0xa7c1,
    0xa7c3,
    0xa7c8,
    0xa7ca,
    0xa7cd,
    0xa7d1,
    0xa7d3,
    0xa7d5,
    0xa7d7,
    0xa7d9,
    0xa7db,
    0xa7f6,
    0xa7fa,
    [0xab30, 0xab5a],
    [0xab60, 0xab68],
    [0xab70, 0xabbf],
    [0xfb00, 0xfb06],
    [0xfb13, 0xfb17],
    [0xff41, 0xff5a],
    [0x10428, 0x1044f],
    [0x104d8, 0x104fb],
    [0x10597, 0x105a1],
    [0x105a3, 0x105b1],
    [0x105b3, 0x105b9],
    [0x105bb, 0x105bc],
    [0x10cc0, 0x10cf2],
    [0x10d70, 0x10d85],
    [0x118c0, 0x118df],
    [0x16e60, 0x16e7f],
    [0x1d41a, 0x1d433],
    [0x1d44e, 0x1d454],
    [0x1d456, 0x1d467],
    [0x1d482, 0x1d49b],
    [0x1d4b6, 0x1d4b9],
    0x1d4bb,
    [0x1d4bd, 0x1d4c3],
    [0x1d4c5, 0x1d4cf],
    [0x1d4ea, 0x1d503],
    [0x1d51e, 0x1d537],
    [0x1d552, 0x1d56b],
    [0x1d586, 0x1d59f],
    [0x1d5ba, 0x1d5d3],
    [0x1d5ee, 0x1d607],
    [0x1d622, 0x1d63b],
    [0x1d656, 0x1d66f],
    [0x1d68a, 0x1d6a5],
    [0x1d6c2, 0x1d6da],
    [0x1d6dc, 0x1d6e1],
    [0x1d6fc, 0x1d714],
    [0x1d716, 0x1d71b],
    [0x1d736, 0x1d74e],
    [0x1d750, 0x1d755],
    [0x1d770, 0x1d788],
    [0x1d78a, 0x1d78f],
    [0x1d7aa, 0x1d7c2],
    [0x1d7c4, 0x1d7c9],
    0x1d7cb,
    [0x1df00, 0x1df09],
    [0x1df0b, 0x1df1e],
    [0x1df25, 0x1df2a],
    [0x1e922, 0x1e943],
];

export const unicodeLlSurrogate: UnicodeSurrogateRangeTable = {
    0xd801: [
        [0xdc28, 0xdc4f], // 0x10428..0x1044F
        [0xdcd8, 0xdcfb], // 0x104D8..0x104FB
        [0xdd97, 0xdda1], // 0x10597..0x105A1
        [0xdda3, 0xddb1], // 0x105A3..0x105B1
        [0xddb3, 0xddb9], // 0x105B3..0x105B9
        [0xddbb, 0xddbc], // 0x105BB..0x105BC
    ],
    0xd803: [
        [0xdcc0, 0xdcf2], // 0x10CC0..0x10CF2
        [0xdd70, 0xdd85], // 0x10D70..0x10D85
    ],
    0xd806: [
        [0xdcc0, 0xdcdf], // 0x118C0..0x118DF
    ],
    0xd81b: [
        [0xde60, 0xde7f], // 0x16E60..0x16E7F
    ],
    0xd835: [
        [0xdc1a, 0xdc33], // 0x1D41A..0x1D433
        [0xdc4e, 0xdc54], // 0x1D44E..0x1D454
        [0xdc56, 0xdc67], // 0x1D456..0x1D467
        [0xdc82, 0xdc9b], // 0x1D482..0x1D49B
        [0xdcb6, 0xdcb9], // 0x1D4B6..0x1D4B9
        0xdcbb, // 0x1D4BB
        [0xdcbd, 0xdcc3], // 0x1D4BD..0x1D4C3
        [0xdcc5, 0xdccf], // 0x1D4C5..0x1D4CF
        [0xdcea, 0xdd03], // 0x1D4EA..0x1D503
        [0xdd1e, 0xdd37], // 0x1D51E..0x1D537
        [0xdd52, 0xdd6b], // 0x1D552..0x1D56B
        [0xdd86, 0xdd9f], // 0x1D586..0x1D59F
        [0xddba, 0xddd3], // 0x1D5BA..0x1D5D3
        [0xddee, 0xde07], // 0x1D5EE..0x1D607
        [0xde22, 0xde3b], // 0x1D622..0x1D63B
        [0xde56, 0xde6f], // 0x1D656..0x1D66F
        [0xde8a, 0xdea5], // 0x1D68A..0x1D6A5
        [0xdec2, 0xdeda], // 0x1D6C2..0x1D6DA
        [0xdedc, 0xdee1], // 0x1D6DC..0x1D6E1
        [0xdefc, 0xdf14], // 0x1D6FC..0x1D714
        [0xdf16, 0xdf1b], // 0x1D716..0x1D71B
        [0xdf36, 0xdf4e], // 0x1D736..0x1D74E
        [0xdf50, 0xdf55], // 0x1D750..0x1D755
        [0xdf70, 0xdf88], // 0x1D770..0x1D788
        [0xdf8a, 0xdf8f], // 0x1D78A..0x1D78F
        [0xdfaa, 0xdfc2], // 0x1D7AA..0x1D7C2
        [0xdfc4, 0xdfc9], // 0x1D7C4..0x1D7C9
        0xdfcb, // 0x1D7CB
    ],
    0xd837: [
        [0xdf00, 0xdf09], // 0x1DF00..0x1DF09
        [0xdf0b, 0xdf1e], // 0x1DF0B..0x1DF1E
        [0xdf25, 0xdf2a], // 0x1DF25..0x1DF2A
    ],
    0xd83a: [
        [0xdd22, 0xdd43], // 0x1E922..0x1E943
    ],
};

export const unicodeLt: UnicodeRangeTable = [
    0x01c5,
    0x01c8,
    0x01cb,
    0x01f2,
    [0x1f88, 0x1f8f],
    [0x1f98, 0x1f9f],
    [0x1fa8, 0x1faf],
    0x1fbc,
    0x1fcc,
    0x1ffc,
];

export const unicodeLo: UnicodeRangeTable = [
    0x00aa,
    0x00ba,
    0x01bb,
    [0x01c0, 0x01c3],
    0x0294,
    [0x05d0, 0x05ea],
    [0x05ef, 0x05f2],
    [0x0620, 0x063f],
    [0x0641, 0x064a],
    [0x066e, 0x066f],
    [0x0671, 0x06d3],
    0x06d5,
    [0x06ee, 0x06ef],
    [0x06fa, 0x06fc],
    0x06ff,
    0x0710,
    [0x0712, 0x072f],
    [0x074d, 0x07a5],
    0x07b1,
    [0x07ca, 0x07ea],
    [0x0800, 0x0815],
    [0x0840, 0x0858],
    [0x0860, 0x086a],
    [0x0870, 0x0887],
    [0x0889, 0x088e],
    [0x08a0, 0x08c8],
    [0x0904, 0x0939],
    0x093d,
    0x0950,
    [0x0958, 0x0961],
    [0x0972, 0x0980],
    [0x0985, 0x098c],
    [0x098f, 0x0990],
    [0x0993, 0x09a8],
    [0x09aa, 0x09b0],
    0x09b2,
    [0x09b6, 0x09b9],
    0x09bd,
    0x09ce,
    [0x09dc, 0x09dd],
    [0x09df, 0x09e1],
    [0x09f0, 0x09f1],
    0x09fc,
    [0x0a05, 0x0a0a],
    [0x0a0f, 0x0a10],
    [0x0a13, 0x0a28],
    [0x0a2a, 0x0a30],
    [0x0a32, 0x0a33],
    [0x0a35, 0x0a36],
    [0x0a38, 0x0a39],
    [0x0a59, 0x0a5c],
    0x0a5e,
    [0x0a72, 0x0a74],
    [0x0a85, 0x0a8d],
    [0x0a8f, 0x0a91],
    [0x0a93, 0x0aa8],
    [0x0aaa, 0x0ab0],
    [0x0ab2, 0x0ab3],
    [0x0ab5, 0x0ab9],
    0x0abd,
    0x0ad0,
    [0x0ae0, 0x0ae1],
    0x0af9,
    [0x0b05, 0x0b0c],
    [0x0b0f, 0x0b10],
    [0x0b13, 0x0b28],
    [0x0b2a, 0x0b30],
    [0x0b32, 0x0b33],
    [0x0b35, 0x0b39],
    0x0b3d,
    [0x0b5c, 0x0b5d],
    [0x0b5f, 0x0b61],
    0x0b71,
    0x0b83,
    [0x0b85, 0x0b8a],
    [0x0b8e, 0x0b90],
    [0x0b92, 0x0b95],
    [0x0b99, 0x0b9a],
    0x0b9c,
    [0x0b9e, 0x0b9f],
    [0x0ba3, 0x0ba4],
    [0x0ba8, 0x0baa],
    [0x0bae, 0x0bb9],
    0x0bd0,
    [0x0c05, 0x0c0c],
    [0x0c0e, 0x0c10],
    [0x0c12, 0x0c28],
    [0x0c2a, 0x0c39],
    0x0c3d,
    [0x0c58, 0x0c5a],
    0x0c5d,
    [0x0c60, 0x0c61],
    0x0c80,
    [0x0c85, 0x0c8c],
    [0x0c8e, 0x0c90],
    [0x0c92, 0x0ca8],
    [0x0caa, 0x0cb3],
    [0x0cb5, 0x0cb9],
    0x0cbd,
    [0x0cdd, 0x0cde],
    [0x0ce0, 0x0ce1],
    [0x0cf1, 0x0cf2],
    [0x0d04, 0x0d0c],
    [0x0d0e, 0x0d10],
    [0x0d12, 0x0d3a],
    0x0d3d,
    0x0d4e,
    [0x0d54, 0x0d56],
    [0x0d5f, 0x0d61],
    [0x0d7a, 0x0d7f],
    [0x0d85, 0x0d96],
    [0x0d9a, 0x0db1],
    [0x0db3, 0x0dbb],
    0x0dbd,
    [0x0dc0, 0x0dc6],
    [0x0e01, 0x0e30],
    [0x0e32, 0x0e33],
    [0x0e40, 0x0e45],
    [0x0e81, 0x0e82],
    0x0e84,
    [0x0e86, 0x0e8a],
    [0x0e8c, 0x0ea3],
    0x0ea5,
    [0x0ea7, 0x0eb0],
    [0x0eb2, 0x0eb3],
    0x0ebd,
    [0x0ec0, 0x0ec4],
    [0x0edc, 0x0edf],
    0x0f00,
    [0x0f40, 0x0f47],
    [0x0f49, 0x0f6c],
    [0x0f88, 0x0f8c],
    [0x1000, 0x102a],
    0x103f,
    [0x1050, 0x1055],
    [0x105a, 0x105d],
    0x1061,
    [0x1065, 0x1066],
    [0x106e, 0x1070],
    [0x1075, 0x1081],
    0x108e,
    [0x1100, 0x1248],
    [0x124a, 0x124d],
    [0x1250, 0x1256],
    0x1258,
    [0x125a, 0x125d],
    [0x1260, 0x1288],
    [0x128a, 0x128d],
    [0x1290, 0x12b0],
    [0x12b2, 0x12b5],
    [0x12b8, 0x12be],
    0x12c0,
    [0x12c2, 0x12c5],
    [0x12c8, 0x12d6],
    [0x12d8, 0x1310],
    [0x1312, 0x1315],
    [0x1318, 0x135a],
    [0x1380, 0x138f],
    [0x1401, 0x166c],
    [0x166f, 0x167f],
    [0x1681, 0x169a],
    [0x16a0, 0x16ea],
    [0x16f1, 0x16f8],
    [0x1700, 0x1711],
    [0x171f, 0x1731],
    [0x1740, 0x1751],
    [0x1760, 0x176c],
    [0x176e, 0x1770],
    [0x1780, 0x17b3],
    0x17dc,
    [0x1820, 0x1842],
    [0x1844, 0x1878],
    [0x1880, 0x1884],
    [0x1887, 0x18a8],
    0x18aa,
    [0x18b0, 0x18f5],
    [0x1900, 0x191e],
    [0x1950, 0x196d],
    [0x1970, 0x1974],
    [0x1980, 0x19ab],
    [0x19b0, 0x19c9],
    [0x1a00, 0x1a16],
    [0x1a20, 0x1a54],
    [0x1b05, 0x1b33],
    [0x1b45, 0x1b4c],
    [0x1b83, 0x1ba0],
    [0x1bae, 0x1baf],
    [0x1bba, 0x1be5],
    [0x1c00, 0x1c23],
    [0x1c4d, 0x1c4f],
    [0x1c5a, 0x1c77],
    [0x1ce9, 0x1cec],
    [0x1cee, 0x1cf3],
    [0x1cf5, 0x1cf6],
    0x1cfa,
    [0x2135, 0x2138],
    [0x2d30, 0x2d67],
    [0x2d80, 0x2d96],
    [0x2da0, 0x2da6],
    [0x2da8, 0x2dae],
    [0x2db0, 0x2db6],
    [0x2db8, 0x2dbe],
    [0x2dc0, 0x2dc6],
    [0x2dc8, 0x2dce],
    [0x2dd0, 0x2dd6],
    [0x2dd8, 0x2dde],
    0x3006,
    0x303c,
    [0x3041, 0x3096],
    0x309f,
    [0x30a1, 0x30fa],
    0x30ff,
    [0x3105, 0x312f],
    [0x3131, 0x318e],
    [0x31a0, 0x31bf],
    [0x31f0, 0x31ff],
    [0x3400, 0x4dbf],
    [0x4e00, 0xa014],
    [0xa016, 0xa48c],
    [0xa4d0, 0xa4f7],
    [0xa500, 0xa60b],
    [0xa610, 0xa61f],
    [0xa62a, 0xa62b],
    0xa66e,
    [0xa6a0, 0xa6e5],
    0xa78f,
    0xa7f7,
    [0xa7fb, 0xa801],
    [0xa803, 0xa805],
    [0xa807, 0xa80a],
    [0xa80c, 0xa822],
    [0xa840, 0xa873],
    [0xa882, 0xa8b3],
    [0xa8f2, 0xa8f7],
    0xa8fb,
    [0xa8fd, 0xa8fe],
    [0xa90a, 0xa925],
    [0xa930, 0xa946],
    [0xa960, 0xa97c],
    [0xa984, 0xa9b2],
    [0xa9e0, 0xa9e4],
    [0xa9e7, 0xa9ef],
    [0xa9fa, 0xa9fe],
    [0xaa00, 0xaa28],
    [0xaa40, 0xaa42],
    [0xaa44, 0xaa4b],
    [0xaa60, 0xaa6f],
    [0xaa71, 0xaa76],
    0xaa7a,
    [0xaa7e, 0xaaaf],
    0xaab1,
    [0xaab5, 0xaab6],
    [0xaab9, 0xaabd],
    0xaac0,
    0xaac2,
    [0xaadb, 0xaadc],
    [0xaae0, 0xaaea],
    0xaaf2,
    [0xab01, 0xab06],
    [0xab09, 0xab0e],
    [0xab11, 0xab16],
    [0xab20, 0xab26],
    [0xab28, 0xab2e],
    [0xabc0, 0xabe2],
    [0xac00, 0xd7a3],
    [0xd7b0, 0xd7c6],
    [0xd7cb, 0xd7fb],
    [0xf900, 0xfa6d],
    [0xfa70, 0xfad9],
    0xfb1d,
    [0xfb1f, 0xfb28],
    [0xfb2a, 0xfb36],
    [0xfb38, 0xfb3c],
    0xfb3e,
    [0xfb40, 0xfb41],
    [0xfb43, 0xfb44],
    [0xfb46, 0xfbb1],
    [0xfbd3, 0xfd3d],
    [0xfd50, 0xfd8f],
    [0xfd92, 0xfdc7],
    [0xfdf0, 0xfdfb],
    [0xfe70, 0xfe74],
    [0xfe76, 0xfefc],
    [0xff66, 0xff6f],
    [0xff71, 0xff9d],
    [0xffa0, 0xffbe],
    [0xffc2, 0xffc7],
    [0xffca, 0xffcf],
    [0xffd2, 0xffd7],
    [0xffda, 0xffdc],
    [0x10000, 0x1000b],
    [0x1000d, 0x10026],
    [0x10028, 0x1003a],
    [0x1003c, 0x1003d],
    [0x1003f, 0x1004d],
    [0x10050, 0x1005d],
    [0x10080, 0x100fa],
    [0x10280, 0x1029c],
    [0x102a0, 0x102d0],
    [0x10300, 0x1031f],
    [0x1032d, 0x10340],
    [0x10342, 0x10349],
    [0x10350, 0x10375],
    [0x10380, 0x1039d],
    [0x103a0, 0x103c3],
    [0x103c8, 0x103cf],
    [0x10450, 0x1049d],
    [0x10500, 0x10527],
    [0x10530, 0x10563],
    [0x105c0, 0x105f3],
    [0x10600, 0x10736],
    [0x10740, 0x10755],
    [0x10760, 0x10767],
    [0x10800, 0x10805],
    0x10808,
    [0x1080a, 0x10835],
    [0x10837, 0x10838],
    0x1083c,
    [0x1083f, 0x10855],
    [0x10860, 0x10876],
    [0x10880, 0x1089e],
    [0x108e0, 0x108f2],
    [0x108f4, 0x108f5],
    [0x10900, 0x10915],
    [0x10920, 0x10939],
    [0x10980, 0x109b7],
    [0x109be, 0x109bf],
    0x10a00,
    [0x10a10, 0x10a13],
    [0x10a15, 0x10a17],
    [0x10a19, 0x10a35],
    [0x10a60, 0x10a7c],
    [0x10a80, 0x10a9c],
    [0x10ac0, 0x10ac7],
    [0x10ac9, 0x10ae4],
    [0x10b00, 0x10b35],
    [0x10b40, 0x10b55],
    [0x10b60, 0x10b72],
    [0x10b80, 0x10b91],
    [0x10c00, 0x10c48],
    [0x10d00, 0x10d23],
    [0x10d4a, 0x10d4d],
    0x10d4f,
    [0x10e80, 0x10ea9],
    [0x10eb0, 0x10eb1],
    [0x10ec2, 0x10ec4],
    [0x10f00, 0x10f1c],
    0x10f27,
    [0x10f30, 0x10f45],
    [0x10f70, 0x10f81],
    [0x10fb0, 0x10fc4],
    [0x10fe0, 0x10ff6],
    [0x11003, 0x11037],
    [0x11071, 0x11072],
    0x11075,
    [0x11083, 0x110af],
    [0x110d0, 0x110e8],
    [0x11103, 0x11126],
    0x11144,
    0x11147,
    [0x11150, 0x11172],
    0x11176,
    [0x11183, 0x111b2],
    [0x111c1, 0x111c4],
    0x111da,
    0x111dc,
    [0x11200, 0x11211],
    [0x11213, 0x1122b],
    [0x1123f, 0x11240],
    [0x11280, 0x11286],
    0x11288,
    [0x1128a, 0x1128d],
    [0x1128f, 0x1129d],
    [0x1129f, 0x112a8],
    [0x112b0, 0x112de],
    [0x11305, 0x1130c],
    [0x1130f, 0x11310],
    [0x11313, 0x11328],
    [0x1132a, 0x11330],
    [0x11332, 0x11333],
    [0x11335, 0x11339],
    0x1133d,
    0x11350,
    [0x1135d, 0x11361],
    [0x11380, 0x11389],
    0x1138b,
    0x1138e,
    [0x11390, 0x113b5],
    0x113b7,
    0x113d1,
    0x113d3,
    [0x11400, 0x11434],
    [0x11447, 0x1144a],
    [0x1145f, 0x11461],
    [0x11480, 0x114af],
    [0x114c4, 0x114c5],
    0x114c7,
    [0x11580, 0x115ae],
    [0x115d8, 0x115db],
    [0x11600, 0x1162f],
    0x11644,
    [0x11680, 0x116aa],
    0x116b8,
    [0x11700, 0x1171a],
    [0x11740, 0x11746],
    [0x11800, 0x1182b],
    [0x118ff, 0x11906],
    0x11909,
    [0x1190c, 0x11913],
    [0x11915, 0x11916],
    [0x11918, 0x1192f],
    0x1193f,
    0x11941,
    [0x119a0, 0x119a7],
    [0x119aa, 0x119d0],
    0x119e1,
    0x119e3,
    0x11a00,
    [0x11a0b, 0x11a32],
    0x11a3a,
    0x11a50,
    [0x11a5c, 0x11a89],
    0x11a9d,
    [0x11ab0, 0x11af8],
    [0x11bc0, 0x11be0],
    [0x11c00, 0x11c08],
    [0x11c0a, 0x11c2e],
    0x11c40,
    [0x11c72, 0x11c8f],
    [0x11d00, 0x11d06],
    [0x11d08, 0x11d09],
    [0x11d0b, 0x11d30],
    0x11d46,
    [0x11d60, 0x11d65],
    [0x11d67, 0x11d68],
    [0x11d6a, 0x11d89],
    0x11d98,
    [0x11ee0, 0x11ef2],
    0x11f02,
    [0x11f04, 0x11f10],
    [0x11f12, 0x11f33],
    0x11fb0,
    [0x12000, 0x12399],
    [0x12480, 0x12543],
    [0x12f90, 0x12ff0],
    [0x13000, 0x1342f],
    [0x13441, 0x13446],
    [0x13460, 0x143fa],
    [0x14400, 0x14646],
    [0x16100, 0x1611d],
    [0x16800, 0x16a38],
    [0x16a40, 0x16a5e],
    [0x16a70, 0x16abe],
    [0x16ad0, 0x16aed],
    [0x16b00, 0x16b2f],
    [0x16b63, 0x16b77],
    [0x16b7d, 0x16b8f],
    [0x16d43, 0x16d6a],
    [0x16f00, 0x16f4a],
    0x16f50,
    [0x17000, 0x187f7],
    [0x18800, 0x18cd5],
    [0x18cff, 0x18d08],
    [0x1b000, 0x1b122],
    0x1b132,
    [0x1b150, 0x1b152],
    0x1b155,
    [0x1b164, 0x1b167],
    [0x1b170, 0x1b2fb],
    [0x1bc00, 0x1bc6a],
    [0x1bc70, 0x1bc7c],
    [0x1bc80, 0x1bc88],
    [0x1bc90, 0x1bc99],
    0x1df0a,
    [0x1e100, 0x1e12c],
    0x1e14e,
    [0x1e290, 0x1e2ad],
    [0x1e2c0, 0x1e2eb],
    [0x1e4d0, 0x1e4ea],
    [0x1e5d0, 0x1e5ed],
    0x1e5f0,
    [0x1e7e0, 0x1e7e6],
    [0x1e7e8, 0x1e7eb],
    [0x1e7ed, 0x1e7ee],
    [0x1e7f0, 0x1e7fe],
    [0x1e800, 0x1e8c4],
    [0x1ee00, 0x1ee03],
    [0x1ee05, 0x1ee1f],
    [0x1ee21, 0x1ee22],
    0x1ee24,
    0x1ee27,
    [0x1ee29, 0x1ee32],
    [0x1ee34, 0x1ee37],
    0x1ee39,
    0x1ee3b,
    0x1ee42,
    0x1ee47,
    0x1ee49,
    0x1ee4b,
    [0x1ee4d, 0x1ee4f],
    [0x1ee51, 0x1ee52],
    0x1ee54,
    0x1ee57,
    0x1ee59,
    0x1ee5b,
    0x1ee5d,
    0x1ee5f,
    [0x1ee61, 0x1ee62],
    0x1ee64,
    [0x1ee67, 0x1ee6a],
    [0x1ee6c, 0x1ee72],
    [0x1ee74, 0x1ee77],
    [0x1ee79, 0x1ee7c],
    0x1ee7e,
    [0x1ee80, 0x1ee89],
    [0x1ee8b, 0x1ee9b],
    [0x1eea1, 0x1eea3],
    [0x1eea5, 0x1eea9],
    [0x1eeab, 0x1eebb],
    [0x20000, 0x2a6df],
    [0x2a700, 0x2b739],
    [0x2b740, 0x2b81d],
    [0x2b820, 0x2cea1],
    [0x2ceb0, 0x2ebe0],
    [0x2ebf0, 0x2ee5d],
    [0x2f800, 0x2fa1d],
    [0x30000, 0x3134a],
    [0x31350, 0x323af],
];

export const unicodeLoSurrogate: UnicodeSurrogateRangeTable = {
    0xd800: [
        [0xdc00, 0xdc0b], // 0x10000..0x1000B
        [0xdc0d, 0xdc26], // 0x1000D..0x10026
        [0xdc28, 0xdc3a], // 0x10028..0x1003A
        [0xdc3c, 0xdc3d], // 0x1003C..0x1003D
        [0xdc3f, 0xdc4d], // 0x1003F..0x1004D
        [0xdc50, 0xdc5d], // 0x10050..0x1005D
        [0xdc80, 0xdcfa], // 0x10080..0x100FA
        [0xde80, 0xde9c], // 0x10280..0x1029C
        [0xdea0, 0xded0], // 0x102A0..0x102D0
        [0xdf00, 0xdf1f], // 0x10300..0x1031F
        [0xdf2d, 0xdf40], // 0x1032D..0x10340
        [0xdf42, 0xdf49], // 0x10342..0x10349
        [0xdf50, 0xdf75], // 0x10350..0x10375
        [0xdf80, 0xdf9d], // 0x10380..0x1039D
        [0xdfa0, 0xdfc3], // 0x103A0..0x103C3
        [0xdfc8, 0xdfcf], // 0x103C8..0x103CF
    ],
    0xd801: [
        [0xdc50, 0xdc9d], // 0x10450..0x1049D
        [0xdd00, 0xdd27], // 0x10500..0x10527
        [0xdd30, 0xdd63], // 0x10530..0x10563
        [0xddc0, 0xddf3], // 0x105C0..0x105F3
        [0xde00, 0xdf36], // 0x10600..0x10736
        [0xdf40, 0xdf55], // 0x10740..0x10755
        [0xdf60, 0xdf67], // 0x10760..0x10767
    ],
    0xd802: [
        [0xdc00, 0xdc05], // 0x10800..0x10805
        0xdc08, // 0x10808
        [0xdc0a, 0xdc35], // 0x1080A..0x10835
        [0xdc37, 0xdc38], // 0x10837..0x10838
        0xdc3c, // 0x1083C
        [0xdc3f, 0xdc55], // 0x1083F..0x10855
        [0xdc60, 0xdc76], // 0x10860..0x10876
        [0xdc80, 0xdc9e], // 0x10880..0x1089E
        [0xdce0, 0xdcf2], // 0x108E0..0x108F2
        [0xdcf4, 0xdcf5], // 0x108F4..0x108F5
        [0xdd00, 0xdd15], // 0x10900..0x10915
        [0xdd20, 0xdd39], // 0x10920..0x10939
        [0xdd80, 0xddb7], // 0x10980..0x109B7
        [0xddbe, 0xddbf], // 0x109BE..0x109BF
        0xde00, // 0x10A00
        [0xde10, 0xde13], // 0x10A10..0x10A13
        [0xde15, 0xde17], // 0x10A15..0x10A17
        [0xde19, 0xde35], // 0x10A19..0x10A35
        [0xde60, 0xde7c], // 0x10A60..0x10A7C
        [0xde80, 0xde9c], // 0x10A80..0x10A9C
        [0xdec0, 0xdec7], // 0x10AC0..0x10AC7
        [0xdec9, 0xdee4], // 0x10AC9..0x10AE4
        [0xdf00, 0xdf35], // 0x10B00..0x10B35
        [0xdf40, 0xdf55], // 0x10B40..0x10B55
        [0xdf60, 0xdf72], // 0x10B60..0x10B72
        [0xdf80, 0xdf91], // 0x10B80..0x10B91
    ],
    0xd803: [
        [0xdc00, 0xdc48], // 0x10C00..0x10C48
        [0xdd00, 0xdd23], // 0x10D00..0x10D23
        [0xdd4a, 0xdd4d], // 0x10D4A..0x10D4D
        0xdd4f, // 0x10D4F
        [0xde80, 0xdea9], // 0x10E80..0x10EA9
        [0xdeb0, 0xdeb1], // 0x10EB0..0x10EB1
        [0xdec2, 0xdec4], // 0x10EC2..0x10EC4
        [0xdf00, 0xdf1c], // 0x10F00..0x10F1C
        0xdf27, // 0x10F27
        [0xdf30, 0xdf45], // 0x10F30..0x10F45
        [0xdf70, 0xdf81], // 0x10F70..0x10F81
        [0xdfb0, 0xdfc4], // 0x10FB0..0x10FC4
        [0xdfe0, 0xdff6], // 0x10FE0..0x10FF6
    ],
    0xd804: [
        [0xdc03, 0xdc37], // 0x11003..0x11037
        [0xdc71, 0xdc72], // 0x11071..0x11072
        0xdc75, // 0x11075
        [0xdc83, 0xdcaf], // 0x11083..0x110AF
        [0xdcd0, 0xdce8], // 0x110D0..0x110E8
        [0xdd03, 0xdd26], // 0x11103..0x11126
        0xdd44, // 0x11144
        0xdd47, // 0x11147
        [0xdd50, 0xdd72], // 0x11150..0x11172
        0xdd76, // 0x11176
        [0xdd83, 0xddb2], // 0x11183..0x111B2
        [0xddc1, 0xddc4], // 0x111C1..0x111C4
        0xddda, // 0x111DA
        0xdddc, // 0x111DC
        [0xde00, 0xde11], // 0x11200..0x11211
        [0xde13, 0xde2b], // 0x11213..0x1122B
        [0xde3f, 0xde40], // 0x1123F..0x11240
        [0xde80, 0xde86], // 0x11280..0x11286
        0xde88, // 0x11288
        [0xde8a, 0xde8d], // 0x1128A..0x1128D
        [0xde8f, 0xde9d], // 0x1128F..0x1129D
        [0xde9f, 0xdea8], // 0x1129F..0x112A8
        [0xdeb0, 0xdede], // 0x112B0..0x112DE
        [0xdf05, 0xdf0c], // 0x11305..0x1130C
        [0xdf0f, 0xdf10], // 0x1130F..0x11310
        [0xdf13, 0xdf28], // 0x11313..0x11328
        [0xdf2a, 0xdf30], // 0x1132A..0x11330
        [0xdf32, 0xdf33], // 0x11332..0x11333
        [0xdf35, 0xdf39], // 0x11335..0x11339
        0xdf3d, // 0x1133D
        0xdf50, // 0x11350
        [0xdf5d, 0xdf61], // 0x1135D..0x11361
        [0xdf80, 0xdf89], // 0x11380..0x11389
        0xdf8b, // 0x1138B
        0xdf8e, // 0x1138E
        [0xdf90, 0xdfb5], // 0x11390..0x113B5
        0xdfb7, // 0x113B7
        0xdfd1, // 0x113D1
        0xdfd3, // 0x113D3
    ],
    0xd805: [
        [0xdc00, 0xdc34], // 0x11400..0x11434
        [0xdc47, 0xdc4a], // 0x11447..0x1144A
        [0xdc5f, 0xdc61], // 0x1145F..0x11461
        [0xdc80, 0xdcaf], // 0x11480..0x114AF
        [0xdcc4, 0xdcc5], // 0x114C4..0x114C5
        0xdcc7, // 0x114C7
        [0xdd80, 0xddae], // 0x11580..0x115AE
        [0xddd8, 0xdddb], // 0x115D8..0x115DB
        [0xde00, 0xde2f], // 0x11600..0x1162F
        0xde44, // 0x11644
        [0xde80, 0xdeaa], // 0x11680..0x116AA
        0xdeb8, // 0x116B8
        [0xdf00, 0xdf1a], // 0x11700..0x1171A
        [0xdf40, 0xdf46], // 0x11740..0x11746
    ],
    0xd806: [
        [0xdc00, 0xdc2b], // 0x11800..0x1182B
        [0xdcff, 0xdd06], // 0x118FF..0x11906
        0xdd09, // 0x11909
        [0xdd0c, 0xdd13], // 0x1190C..0x11913
        [0xdd15, 0xdd16], // 0x11915..0x11916
        [0xdd18, 0xdd2f], // 0x11918..0x1192F
        0xdd3f, // 0x1193F
        0xdd41, // 0x11941
        [0xdda0, 0xdda7], // 0x119A0..0x119A7
        [0xddaa, 0xddd0], // 0x119AA..0x119D0
        0xdde1, // 0x119E1
        0xdde3, // 0x119E3
        0xde00, // 0x11A00
        [0xde0b, 0xde32], // 0x11A0B..0x11A32
        0xde3a, // 0x11A3A
        0xde50, // 0x11A50
        [0xde5c, 0xde89], // 0x11A5C..0x11A89
        0xde9d, // 0x11A9D
        [0xdeb0, 0xdef8], // 0x11AB0..0x11AF8
        [0xdfc0, 0xdfe0], // 0x11BC0..0x11BE0
    ],
    0xd807: [
        [0xdc00, 0xdc08], // 0x11C00..0x11C08
        [0xdc0a, 0xdc2e], // 0x11C0A..0x11C2E
        0xdc40, // 0x11C40
        [0xdc72, 0xdc8f], // 0x11C72..0x11C8F
        [0xdd00, 0xdd06], // 0x11D00..0x11D06
        [0xdd08, 0xdd09], // 0x11D08..0x11D09
        [0xdd0b, 0xdd30], // 0x11D0B..0x11D30
        0xdd46, // 0x11D46
        [0xdd60, 0xdd65], // 0x11D60..0x11D65
        [0xdd67, 0xdd68], // 0x11D67..0x11D68
        [0xdd6a, 0xdd89], // 0x11D6A..0x11D89
        0xdd98, // 0x11D98
        [0xdee0, 0xdef2], // 0x11EE0..0x11EF2
        0xdf02, // 0x11F02
        [0xdf04, 0xdf10], // 0x11F04..0x11F10
        [0xdf12, 0xdf33], // 0x11F12..0x11F33
        0xdfb0, // 0x11FB0
    ],
    0xd808: [
        [0xdc00, 0xdf99], // 0x12000..0x12399
    ],
    0xd809: [
        [0xdc80, 0xdd43], // 0x12480..0x12543
    ],
    0xd80b: [
        [0xdf90, 0xdff0], // 0x12F90..0x12FF0
    ],
    0xd80c: [
        [0xdc00, 0xdfff], // 0x13000..0x133FF
    ],
    0xd80d: [
        [0xdc00, 0xdc2f], // 0x13400..0x1342F
        [0xdc41, 0xdc46], // 0x13441..0x13446
        [0xdc60, 0xdfff], // 0x13460..0x137FF
    ],
    0xd80e: [
        [0xdc00, 0xdfff], // 0x13800..0x13BFF
    ],
    0xd80f: [
        [0xdc00, 0xdfff], // 0x13C00..0x13FFF
    ],
    0xd810: [
        [0xdc00, 0xdffa], // 0x14000..0x143FA
    ],
    0xd811: [
        [0xdc00, 0xde46], // 0x14400..0x14646
    ],
    0xd818: [
        [0xdd00, 0xdd1d], // 0x16100..0x1611D
    ],
    0xd81a: [
        [0xdc00, 0xde38], // 0x16800..0x16A38
        [0xde40, 0xde5e], // 0x16A40..0x16A5E
        [0xde70, 0xdebe], // 0x16A70..0x16ABE
        [0xded0, 0xdeed], // 0x16AD0..0x16AED
        [0xdf00, 0xdf2f], // 0x16B00..0x16B2F
        [0xdf63, 0xdf77], // 0x16B63..0x16B77
        [0xdf7d, 0xdf8f], // 0x16B7D..0x16B8F
    ],
    0xd81b: [
        [0xdd43, 0xdd6a], // 0x16D43..0x16D6A
        [0xdf00, 0xdf4a], // 0x16F00..0x16F4A
        0xdf50, // 0x16F50
    ],
    0xd81c: [
        [0xdc00, 0xdfff], // 0x17000..0x173FF
    ],
    0xd81d: [
        [0xdc00, 0xdfff], // 0x17400..0x177FF
    ],
    0xd81e: [
        [0xdc00, 0xdfff], // 0x17800..0x17BFF
    ],
    0xd81f: [
        [0xdc00, 0xdfff], // 0x17C00..0x17FFF
    ],
    0xd820: [
        [0xdc00, 0xdfff], // 0x18000..0x183FF
    ],
    0xd821: [
        [0xdc00, 0xdff7], // 0x18400..0x187F7
    ],
    0xd822: [
        [0xdc00, 0xdfff], // 0x18800..0x18BFF
    ],
    0xd823: [
        [0xdc00, 0xdcd5], // 0x18C00..0x18CD5
        [0xdcff, 0xdd08], // 0x18CFF..0x18D08
    ],
    0xd82c: [
        [0xdc00, 0xdd22], // 0x1B000..0x1B122
        0xdd32, // 0x1B132
        [0xdd50, 0xdd52], // 0x1B150..0x1B152
        0xdd55, // 0x1B155
        [0xdd64, 0xdd67], // 0x1B164..0x1B167
        [0xdd70, 0xdefb], // 0x1B170..0x1B2FB
    ],
    0xd82f: [
        [0xdc00, 0xdc6a], // 0x1BC00..0x1BC6A
        [0xdc70, 0xdc7c], // 0x1BC70..0x1BC7C
        [0xdc80, 0xdc88], // 0x1BC80..0x1BC88
        [0xdc90, 0xdc99], // 0x1BC90..0x1BC99
    ],
    0xd837: [
        0xdf0a, // 0x1DF0A
    ],
    0xd838: [
        [0xdd00, 0xdd2c], // 0x1E100..0x1E12C
        0xdd4e, // 0x1E14E
        [0xde90, 0xdead], // 0x1E290..0x1E2AD
        [0xdec0, 0xdeeb], // 0x1E2C0..0x1E2EB
    ],
    0xd839: [
        [0xdcd0, 0xdcea], // 0x1E4D0..0x1E4EA
        [0xddd0, 0xdded], // 0x1E5D0..0x1E5ED
        0xddf0, // 0x1E5F0
        [0xdfe0, 0xdfe6], // 0x1E7E0..0x1E7E6
        [0xdfe8, 0xdfeb], // 0x1E7E8..0x1E7EB
        [0xdfed, 0xdfee], // 0x1E7ED..0x1E7EE
        [0xdff0, 0xdffe], // 0x1E7F0..0x1E7FE
    ],
    0xd83a: [
        [0xdc00, 0xdcc4], // 0x1E800..0x1E8C4
    ],
    0xd83b: [
        [0xde00, 0xde03], // 0x1EE00..0x1EE03
        [0xde05, 0xde1f], // 0x1EE05..0x1EE1F
        [0xde21, 0xde22], // 0x1EE21..0x1EE22
        0xde24, // 0x1EE24
        0xde27, // 0x1EE27
        [0xde29, 0xde32], // 0x1EE29..0x1EE32
        [0xde34, 0xde37], // 0x1EE34..0x1EE37
        0xde39, // 0x1EE39
        0xde3b, // 0x1EE3B
        0xde42, // 0x1EE42
        0xde47, // 0x1EE47
        0xde49, // 0x1EE49
        0xde4b, // 0x1EE4B
        [0xde4d, 0xde4f], // 0x1EE4D..0x1EE4F
        [0xde51, 0xde52], // 0x1EE51..0x1EE52
        0xde54, // 0x1EE54
        0xde57, // 0x1EE57
        0xde59, // 0x1EE59
        0xde5b, // 0x1EE5B
        0xde5d, // 0x1EE5D
        0xde5f, // 0x1EE5F
        [0xde61, 0xde62], // 0x1EE61..0x1EE62
        0xde64, // 0x1EE64
        [0xde67, 0xde6a], // 0x1EE67..0x1EE6A
        [0xde6c, 0xde72], // 0x1EE6C..0x1EE72
        [0xde74, 0xde77], // 0x1EE74..0x1EE77
        [0xde79, 0xde7c], // 0x1EE79..0x1EE7C
        0xde7e, // 0x1EE7E
        [0xde80, 0xde89], // 0x1EE80..0x1EE89
        [0xde8b, 0xde9b], // 0x1EE8B..0x1EE9B
        [0xdea1, 0xdea3], // 0x1EEA1..0x1EEA3
        [0xdea5, 0xdea9], // 0x1EEA5..0x1EEA9
        [0xdeab, 0xdebb], // 0x1EEAB..0x1EEBB
    ],
    0xd840: [
        [0xdc00, 0xdfff], // 0x20000..0x203FF
    ],
    0xd841: [
        [0xdc00, 0xdfff], // 0x20400..0x207FF
    ],
    0xd842: [
        [0xdc00, 0xdfff], // 0x20800..0x20BFF
    ],
    0xd843: [
        [0xdc00, 0xdfff], // 0x20C00..0x20FFF
    ],
    0xd844: [
        [0xdc00, 0xdfff], // 0x21000..0x213FF
    ],
    0xd845: [
        [0xdc00, 0xdfff], // 0x21400..0x217FF
    ],
    0xd846: [
        [0xdc00, 0xdfff], // 0x21800..0x21BFF
    ],
    0xd847: [
        [0xdc00, 0xdfff], // 0x21C00..0x21FFF
    ],
    0xd848: [
        [0xdc00, 0xdfff], // 0x22000..0x223FF
    ],
    0xd849: [
        [0xdc00, 0xdfff], // 0x22400..0x227FF
    ],
    0xd84a: [
        [0xdc00, 0xdfff], // 0x22800..0x22BFF
    ],
    0xd84b: [
        [0xdc00, 0xdfff], // 0x22C00..0x22FFF
    ],
    0xd84c: [
        [0xdc00, 0xdfff], // 0x23000..0x233FF
    ],
    0xd84d: [
        [0xdc00, 0xdfff], // 0x23400..0x237FF
    ],
    0xd84e: [
        [0xdc00, 0xdfff], // 0x23800..0x23BFF
    ],
    0xd84f: [
        [0xdc00, 0xdfff], // 0x23C00..0x23FFF
    ],
    0xd850: [
        [0xdc00, 0xdfff], // 0x24000..0x243FF
    ],
    0xd851: [
        [0xdc00, 0xdfff], // 0x24400..0x247FF
    ],
    0xd852: [
        [0xdc00, 0xdfff], // 0x24800..0x24BFF
    ],
    0xd853: [
        [0xdc00, 0xdfff], // 0x24C00..0x24FFF
    ],
    0xd854: [
        [0xdc00, 0xdfff], // 0x25000..0x253FF
    ],
    0xd855: [
        [0xdc00, 0xdfff], // 0x25400..0x257FF
    ],
    0xd856: [
        [0xdc00, 0xdfff], // 0x25800..0x25BFF
    ],
    0xd857: [
        [0xdc00, 0xdfff], // 0x25C00..0x25FFF
    ],
    0xd858: [
        [0xdc00, 0xdfff], // 0x26000..0x263FF
    ],
    0xd859: [
        [0xdc00, 0xdfff], // 0x26400..0x267FF
    ],
    0xd85a: [
        [0xdc00, 0xdfff], // 0x26800..0x26BFF
    ],
    0xd85b: [
        [0xdc00, 0xdfff], // 0x26C00..0x26FFF
    ],
    0xd85c: [
        [0xdc00, 0xdfff], // 0x27000..0x273FF
    ],
    0xd85d: [
        [0xdc00, 0xdfff], // 0x27400..0x277FF
    ],
    0xd85e: [
        [0xdc00, 0xdfff], // 0x27800..0x27BFF
    ],
    0xd85f: [
        [0xdc00, 0xdfff], // 0x27C00..0x27FFF
    ],
    0xd860: [
        [0xdc00, 0xdfff], // 0x28000..0x283FF
    ],
    0xd861: [
        [0xdc00, 0xdfff], // 0x28400..0x287FF
    ],
    0xd862: [
        [0xdc00, 0xdfff], // 0x28800..0x28BFF
    ],
    0xd863: [
        [0xdc00, 0xdfff], // 0x28C00..0x28FFF
    ],
    0xd864: [
        [0xdc00, 0xdfff], // 0x29000..0x293FF
    ],
    0xd865: [
        [0xdc00, 0xdfff], // 0x29400..0x297FF
    ],
    0xd866: [
        [0xdc00, 0xdfff], // 0x29800..0x29BFF
    ],
    0xd867: [
        [0xdc00, 0xdfff], // 0x29C00..0x29FFF
    ],
    0xd868: [
        [0xdc00, 0xdfff], // 0x2A000..0x2A3FF
    ],
    0xd869: [
        [0xdc00, 0xdedf], // 0x2A400..0x2A6DF
        [0xdf00, 0xdfff], // 0x2A700..0x2A7FF
    ],
    0xd86a: [
        [0xdc00, 0xdfff], // 0x2A800..0x2ABFF
    ],
    0xd86b: [
        [0xdc00, 0xdfff], // 0x2AC00..0x2AFFF
    ],
    0xd86c: [
        [0xdc00, 0xdfff], // 0x2B000..0x2B3FF
    ],
    0xd86d: [
        [0xdc00, 0xdf39], // 0x2B400..0x2B739
        [0xdf40, 0xdfff], // 0x2B740..0x2B7FF
    ],
    0xd86e: [
        [0xdc00, 0xdc1d], // 0x2B800..0x2B81D
        [0xdc20, 0xdfff], // 0x2B820..0x2BBFF
    ],
    0xd86f: [
        [0xdc00, 0xdfff], // 0x2BC00..0x2BFFF
    ],
    0xd870: [
        [0xdc00, 0xdfff], // 0x2C000..0x2C3FF
    ],
    0xd871: [
        [0xdc00, 0xdfff], // 0x2C400..0x2C7FF
    ],
    0xd872: [
        [0xdc00, 0xdfff], // 0x2C800..0x2CBFF
    ],
    0xd873: [
        [0xdc00, 0xdea1], // 0x2CC00..0x2CEA1
        [0xdeb0, 0xdfff], // 0x2CEB0..0x2CFFF
    ],
    0xd874: [
        [0xdc00, 0xdfff], // 0x2D000..0x2D3FF
    ],
    0xd875: [
        [0xdc00, 0xdfff], // 0x2D400..0x2D7FF
    ],
    0xd876: [
        [0xdc00, 0xdfff], // 0x2D800..0x2DBFF
    ],
    0xd877: [
        [0xdc00, 0xdfff], // 0x2DC00..0x2DFFF
    ],
    0xd878: [
        [0xdc00, 0xdfff], // 0x2E000..0x2E3FF
    ],
    0xd879: [
        [0xdc00, 0xdfff], // 0x2E400..0x2E7FF
    ],
    0xd87a: [
        [0xdc00, 0xdfe0], // 0x2E800..0x2EBE0
        [0xdff0, 0xdfff], // 0x2EBF0..0x2EBFF
    ],
    0xd87b: [
        [0xdc00, 0xde5d], // 0x2EC00..0x2EE5D
    ],
    0xd87e: [
        [0xdc00, 0xde1d], // 0x2F800..0x2FA1D
    ],
    0xd880: [
        [0xdc00, 0xdfff], // 0x30000..0x303FF
    ],
    0xd881: [
        [0xdc00, 0xdfff], // 0x30400..0x307FF
    ],
    0xd882: [
        [0xdc00, 0xdfff], // 0x30800..0x30BFF
    ],
    0xd883: [
        [0xdc00, 0xdfff], // 0x30C00..0x30FFF
    ],
    0xd884: [
        [0xdc00, 0xdf4a], // 0x31000..0x3134A
        [0xdf50, 0xdfff], // 0x31350..0x313FF
    ],
    0xd885: [
        [0xdc00, 0xdfff], // 0x31400..0x317FF
    ],
    0xd886: [
        [0xdc00, 0xdfff], // 0x31800..0x31BFF
    ],
    0xd887: [
        [0xdc00, 0xdfff], // 0x31C00..0x31FFF
    ],
    0xd888: [
        [0xdc00, 0xdfaf], // 0x32000..0x323AF
    ],
};

export const unicodeLm: UnicodeRangeTable = [
    [0x02b0, 0x02c1],
    [0x02c6, 0x02d1],
    [0x02e0, 0x02e4],
    0x02ec,
    0x02ee,
    0x0374,
    0x037a,
    0x0559,
    0x0640,
    [0x06e5, 0x06e6],
    [0x07f4, 0x07f5],
    0x07fa,
    0x081a,
    0x0824,
    0x0828,
    0x08c9,
    0x0971,
    0x0e46,
    0x0ec6,
    0x10fc,
    0x17d7,
    0x1843,
    0x1aa7,
    [0x1c78, 0x1c7d],
    [0x1d2c, 0x1d6a],
    0x1d78,
    [0x1d9b, 0x1dbf],
    0x2071,
    0x207f,
    [0x2090, 0x209c],
    [0x2c7c, 0x2c7d],
    0x2d6f,
    0x2e2f,
    0x3005,
    [0x3031, 0x3035],
    0x303b,
    [0x309d, 0x309e],
    [0x30fc, 0x30fe],
    0xa015,
    [0xa4f8, 0xa4fd],
    0xa60c,
    0xa67f,
    [0xa69c, 0xa69d],
    [0xa717, 0xa71f],
    0xa770,
    0xa788,
    [0xa7f2, 0xa7f4],
    [0xa7f8, 0xa7f9],
    0xa9cf,
    0xa9e6,
    0xaa70,
    0xaadd,
    [0xaaf3, 0xaaf4],
    [0xab5c, 0xab5f],
    0xab69,
    0xff70,
    [0xff9e, 0xff9f],
    [0x10780, 0x10785],
    [0x10787, 0x107b0],
    [0x107b2, 0x107ba],
    0x10d4e,
    0x10d6f,
    [0x16b40, 0x16b43],
    [0x16d40, 0x16d42],
    [0x16d6b, 0x16d6c],
    [0x16f93, 0x16f9f],
    [0x16fe0, 0x16fe1],
    0x16fe3,
    [0x1aff0, 0x1aff3],
    [0x1aff5, 0x1affb],
    [0x1affd, 0x1affe],
    [0x1e030, 0x1e06d],
    [0x1e137, 0x1e13d],
    0x1e4eb,
    0x1e94b,
];

export const unicodeLmSurrogate: UnicodeSurrogateRangeTable = {
    0xd801: [
        [0xdf80, 0xdf85], // 0x10780..0x10785
        [0xdf87, 0xdfb0], // 0x10787..0x107B0
        [0xdfb2, 0xdfba], // 0x107B2..0x107BA
    ],
    0xd803: [
        0xdd4e, // 0x10D4E
        0xdd6f, // 0x10D6F
    ],
    0xd81a: [
        [0xdf40, 0xdf43], // 0x16B40..0x16B43
    ],
    0xd81b: [
        [0xdd40, 0xdd42], // 0x16D40..0x16D42
        [0xdd6b, 0xdd6c], // 0x16D6B..0x16D6C
        [0xdf93, 0xdf9f], // 0x16F93..0x16F9F
        [0xdfe0, 0xdfe1], // 0x16FE0..0x16FE1
        0xdfe3, // 0x16FE3
    ],
    0xd82b: [
        [0xdff0, 0xdff3], // 0x1AFF0..0x1AFF3
        [0xdff5, 0xdffb], // 0x1AFF5..0x1AFFB
        [0xdffd, 0xdffe], // 0x1AFFD..0x1AFFE
    ],
    0xd838: [
        [0xdc30, 0xdc6d], // 0x1E030..0x1E06D
        [0xdd37, 0xdd3d], // 0x1E137..0x1E13D
    ],
    0xd839: [
        0xdceb, // 0x1E4EB
    ],
    0xd83a: [
        0xdd4b, // 0x1E94B
    ],
};

export const unicodeNl: UnicodeRangeTable = [
    [0x16ee, 0x16f0],
    [0x2160, 0x2182],
    [0x2185, 0x2188],
    0x3007,
    [0x3021, 0x3029],
    [0x3038, 0x303a],
    [0xa6e6, 0xa6ef],
    [0x10140, 0x10174],
    0x10341,
    0x1034a,
    [0x103d1, 0x103d5],
    [0x12400, 0x1246e],
];

export const unicodeNlSurrogate: UnicodeSurrogateRangeTable = {
    0xd800: [
        [0xdd40, 0xdd74], // 0x10140..0x10174
        0xdf41, // 0x10341
        0xdf4a, // 0x1034A
        [0xdfd1, 0xdfd5], // 0x103D1..0x103D5
    ],
    0xd809: [
        [0xdc00, 0xdc6e], // 0x12400..0x1246E
    ],
};

export const unicodeMn: UnicodeRangeTable = [
    [0x0300, 0x036f],
    [0x0483, 0x0487],
    [0x0591, 0x05bd],
    0x05bf,
    [0x05c1, 0x05c2],
    [0x05c4, 0x05c5],
    0x05c7,
    [0x0610, 0x061a],
    [0x064b, 0x065f],
    0x0670,
    [0x06d6, 0x06dc],
    [0x06df, 0x06e4],
    [0x06e7, 0x06e8],
    [0x06ea, 0x06ed],
    0x0711,
    [0x0730, 0x074a],
    [0x07a6, 0x07b0],
    [0x07eb, 0x07f3],
    0x07fd,
    [0x0816, 0x0819],
    [0x081b, 0x0823],
    [0x0825, 0x0827],
    [0x0829, 0x082d],
    [0x0859, 0x085b],
    [0x0897, 0x089f],
    [0x08ca, 0x08e1],
    [0x08e3, 0x0902],
    0x093a,
    0x093c,
    [0x0941, 0x0948],
    0x094d,
    [0x0951, 0x0957],
    [0x0962, 0x0963],
    0x0981,
    0x09bc,
    [0x09c1, 0x09c4],
    0x09cd,
    [0x09e2, 0x09e3],
    0x09fe,
    [0x0a01, 0x0a02],
    0x0a3c,
    [0x0a41, 0x0a42],
    [0x0a47, 0x0a48],
    [0x0a4b, 0x0a4d],
    0x0a51,
    [0x0a70, 0x0a71],
    0x0a75,
    [0x0a81, 0x0a82],
    0x0abc,
    [0x0ac1, 0x0ac5],
    [0x0ac7, 0x0ac8],
    0x0acd,
    [0x0ae2, 0x0ae3],
    [0x0afa, 0x0aff],
    0x0b01,
    0x0b3c,
    0x0b3f,
    [0x0b41, 0x0b44],
    0x0b4d,
    [0x0b55, 0x0b56],
    [0x0b62, 0x0b63],
    0x0b82,
    0x0bc0,
    0x0bcd,
    0x0c00,
    0x0c04,
    0x0c3c,
    [0x0c3e, 0x0c40],
    [0x0c46, 0x0c48],
    [0x0c4a, 0x0c4d],
    [0x0c55, 0x0c56],
    [0x0c62, 0x0c63],
    0x0c81,
    0x0cbc,
    0x0cbf,
    0x0cc6,
    [0x0ccc, 0x0ccd],
    [0x0ce2, 0x0ce3],
    [0x0d00, 0x0d01],
    [0x0d3b, 0x0d3c],
    [0x0d41, 0x0d44],
    0x0d4d,
    [0x0d62, 0x0d63],
    0x0d81,
    0x0dca,
    [0x0dd2, 0x0dd4],
    0x0dd6,
    0x0e31,
    [0x0e34, 0x0e3a],
    [0x0e47, 0x0e4e],
    0x0eb1,
    [0x0eb4, 0x0ebc],
    [0x0ec8, 0x0ece],
    [0x0f18, 0x0f19],
    0x0f35,
    0x0f37,
    0x0f39,
    [0x0f71, 0x0f7e],
    [0x0f80, 0x0f84],
    [0x0f86, 0x0f87],
    [0x0f8d, 0x0f97],
    [0x0f99, 0x0fbc],
    0x0fc6,
    [0x102d, 0x1030],
    [0x1032, 0x1037],
    [0x1039, 0x103a],
    [0x103d, 0x103e],
    [0x1058, 0x1059],
    [0x105e, 0x1060],
    [0x1071, 0x1074],
    0x1082,
    [0x1085, 0x1086],
    0x108d,
    0x109d,
    [0x135d, 0x135f],
    [0x1712, 0x1714],
    [0x1732, 0x1733],
    [0x1752, 0x1753],
    [0x1772, 0x1773],
    [0x17b4, 0x17b5],
    [0x17b7, 0x17bd],
    0x17c6,
    [0x17c9, 0x17d3],
    0x17dd,
    [0x180b, 0x180d],
    0x180f,
    [0x1885, 0x1886],
    0x18a9,
    [0x1920, 0x1922],
    [0x1927, 0x1928],
    0x1932,
    [0x1939, 0x193b],
    [0x1a17, 0x1a18],
    0x1a1b,
    0x1a56,
    [0x1a58, 0x1a5e],
    0x1a60,
    0x1a62,
    [0x1a65, 0x1a6c],
    [0x1a73, 0x1a7c],
    0x1a7f,
    [0x1ab0, 0x1abd],
    [0x1abf, 0x1ace],
    [0x1b00, 0x1b03],
    0x1b34,
    [0x1b36, 0x1b3a],
    0x1b3c,
    0x1b42,
    [0x1b6b, 0x1b73],
    [0x1b80, 0x1b81],
    [0x1ba2, 0x1ba5],
    [0x1ba8, 0x1ba9],
    [0x1bab, 0x1bad],
    0x1be6,
    [0x1be8, 0x1be9],
    0x1bed,
    [0x1bef, 0x1bf1],
    [0x1c2c, 0x1c33],
    [0x1c36, 0x1c37],
    [0x1cd0, 0x1cd2],
    [0x1cd4, 0x1ce0],
    [0x1ce2, 0x1ce8],
    0x1ced,
    0x1cf4,
    [0x1cf8, 0x1cf9],
    [0x1dc0, 0x1dff],
    [0x20d0, 0x20dc],
    0x20e1,
    [0x20e5, 0x20f0],
    [0x2cef, 0x2cf1],
    0x2d7f,
    [0x2de0, 0x2dff],
    [0x302a, 0x302d],
    [0x3099, 0x309a],
    0xa66f,
    [0xa674, 0xa67d],
    [0xa69e, 0xa69f],
    [0xa6f0, 0xa6f1],
    0xa802,
    0xa806,
    0xa80b,
    [0xa825, 0xa826],
    0xa82c,
    [0xa8c4, 0xa8c5],
    [0xa8e0, 0xa8f1],
    0xa8ff,
    [0xa926, 0xa92d],
    [0xa947, 0xa951],
    [0xa980, 0xa982],
    0xa9b3,
    [0xa9b6, 0xa9b9],
    [0xa9bc, 0xa9bd],
    0xa9e5,
    [0xaa29, 0xaa2e],
    [0xaa31, 0xaa32],
    [0xaa35, 0xaa36],
    0xaa43,
    0xaa4c,
    0xaa7c,
    0xaab0,
    [0xaab2, 0xaab4],
    [0xaab7, 0xaab8],
    [0xaabe, 0xaabf],
    0xaac1,
    [0xaaec, 0xaaed],
    0xaaf6,
    0xabe5,
    0xabe8,
    0xabed,
    0xfb1e,
    [0xfe00, 0xfe0f],
    [0xfe20, 0xfe2f],
    0x101fd,
    0x102e0,
    [0x10376, 0x1037a],
    [0x10a01, 0x10a03],
    [0x10a05, 0x10a06],
    [0x10a0c, 0x10a0f],
    [0x10a38, 0x10a3a],
    0x10a3f,
    [0x10ae5, 0x10ae6],
    [0x10d24, 0x10d27],
    [0x10d69, 0x10d6d],
    [0x10eab, 0x10eac],
    [0x10efc, 0x10eff],
    [0x10f46, 0x10f50],
    [0x10f82, 0x10f85],
    0x11001,
    [0x11038, 0x11046],
    0x11070,
    [0x11073, 0x11074],
    [0x1107f, 0x11081],
    [0x110b3, 0x110b6],
    [0x110b9, 0x110ba],
    0x110c2,
    [0x11100, 0x11102],
    [0x11127, 0x1112b],
    [0x1112d, 0x11134],
    0x11173,
    [0x11180, 0x11181],
    [0x111b6, 0x111be],
    [0x111c9, 0x111cc],
    0x111cf,
    [0x1122f, 0x11231],
    0x11234,
    [0x11236, 0x11237],
    0x1123e,
    0x11241,
    0x112df,
    [0x112e3, 0x112ea],
    [0x11300, 0x11301],
    [0x1133b, 0x1133c],
    0x11340,
    [0x11366, 0x1136c],
    [0x11370, 0x11374],
    [0x113bb, 0x113c0],
    0x113ce,
    0x113d0,
    0x113d2,
    [0x113e1, 0x113e2],
    [0x11438, 0x1143f],
    [0x11442, 0x11444],
    0x11446,
    0x1145e,
    [0x114b3, 0x114b8],
    0x114ba,
    [0x114bf, 0x114c0],
    [0x114c2, 0x114c3],
    [0x115b2, 0x115b5],
    [0x115bc, 0x115bd],
    [0x115bf, 0x115c0],
    [0x115dc, 0x115dd],
    [0x11633, 0x1163a],
    0x1163d,
    [0x1163f, 0x11640],
    0x116ab,
    0x116ad,
    [0x116b0, 0x116b5],
    0x116b7,
    0x1171d,
    0x1171f,
    [0x11722, 0x11725],
    [0x11727, 0x1172b],
    [0x1182f, 0x11837],
    [0x11839, 0x1183a],
    [0x1193b, 0x1193c],
    0x1193e,
    0x11943,
    [0x119d4, 0x119d7],
    [0x119da, 0x119db],
    0x119e0,
    [0x11a01, 0x11a0a],
    [0x11a33, 0x11a38],
    [0x11a3b, 0x11a3e],
    0x11a47,
    [0x11a51, 0x11a56],
    [0x11a59, 0x11a5b],
    [0x11a8a, 0x11a96],
    [0x11a98, 0x11a99],
    [0x11c30, 0x11c36],
    [0x11c38, 0x11c3d],
    0x11c3f,
    [0x11c92, 0x11ca7],
    [0x11caa, 0x11cb0],
    [0x11cb2, 0x11cb3],
    [0x11cb5, 0x11cb6],
    [0x11d31, 0x11d36],
    0x11d3a,
    [0x11d3c, 0x11d3d],
    [0x11d3f, 0x11d45],
    0x11d47,
    [0x11d90, 0x11d91],
    0x11d95,
    0x11d97,
    [0x11ef3, 0x11ef4],
    [0x11f00, 0x11f01],
    [0x11f36, 0x11f3a],
    0x11f40,
    0x11f42,
    0x11f5a,
    0x13440,
    [0x13447, 0x13455],
    [0x1611e, 0x16129],
    [0x1612d, 0x1612f],
    [0x16af0, 0x16af4],
    [0x16b30, 0x16b36],
    0x16f4f,
    [0x16f8f, 0x16f92],
    0x16fe4,
    [0x1bc9d, 0x1bc9e],
    [0x1cf00, 0x1cf2d],
    [0x1cf30, 0x1cf46],
    [0x1d167, 0x1d169],
    [0x1d17b, 0x1d182],
    [0x1d185, 0x1d18b],
    [0x1d1aa, 0x1d1ad],
    [0x1d242, 0x1d244],
    [0x1da00, 0x1da36],
    [0x1da3b, 0x1da6c],
    0x1da75,
    0x1da84,
    [0x1da9b, 0x1da9f],
    [0x1daa1, 0x1daaf],
    [0x1e000, 0x1e006],
    [0x1e008, 0x1e018],
    [0x1e01b, 0x1e021],
    [0x1e023, 0x1e024],
    [0x1e026, 0x1e02a],
    0x1e08f,
    [0x1e130, 0x1e136],
    0x1e2ae,
    [0x1e2ec, 0x1e2ef],
    [0x1e4ec, 0x1e4ef],
    [0x1e5ee, 0x1e5ef],
    [0x1e8d0, 0x1e8d6],
    [0x1e944, 0x1e94a],
    [0xe0100, 0xe01ef],
];

export const unicodeMnSurrogate: UnicodeSurrogateRangeTable = {
    0xd800: [
        0xddfd, // 0x101FD
        0xdee0, // 0x102E0
        [0xdf76, 0xdf7a], // 0x10376..0x1037A
    ],
    0xd802: [
        [0xde01, 0xde03], // 0x10A01..0x10A03
        [0xde05, 0xde06], // 0x10A05..0x10A06
        [0xde0c, 0xde0f], // 0x10A0C..0x10A0F
        [0xde38, 0xde3a], // 0x10A38..0x10A3A
        0xde3f, // 0x10A3F
        [0xdee5, 0xdee6], // 0x10AE5..0x10AE6
    ],
    0xd803: [
        [0xdd24, 0xdd27], // 0x10D24..0x10D27
        [0xdd69, 0xdd6d], // 0x10D69..0x10D6D
        [0xdeab, 0xdeac], // 0x10EAB..0x10EAC
        [0xdefc, 0xdeff], // 0x10EFC..0x10EFF
        [0xdf46, 0xdf50], // 0x10F46..0x10F50
        [0xdf82, 0xdf85], // 0x10F82..0x10F85
    ],
    0xd804: [
        0xdc01, // 0x11001
        [0xdc38, 0xdc46], // 0x11038..0x11046
        0xdc70, // 0x11070
        [0xdc73, 0xdc74], // 0x11073..0x11074
        [0xdc7f, 0xdc81], // 0x1107F..0x11081
        [0xdcb3, 0xdcb6], // 0x110B3..0x110B6
        [0xdcb9, 0xdcba], // 0x110B9..0x110BA
        0xdcc2, // 0x110C2
        [0xdd00, 0xdd02], // 0x11100..0x11102
        [0xdd27, 0xdd2b], // 0x11127..0x1112B
        [0xdd2d, 0xdd34], // 0x1112D..0x11134
        0xdd73, // 0x11173
        [0xdd80, 0xdd81], // 0x11180..0x11181
        [0xddb6, 0xddbe], // 0x111B6..0x111BE
        [0xddc9, 0xddcc], // 0x111C9..0x111CC
        0xddcf, // 0x111CF
        [0xde2f, 0xde31], // 0x1122F..0x11231
        0xde34, // 0x11234
        [0xde36, 0xde37], // 0x11236..0x11237
        0xde3e, // 0x1123E
        0xde41, // 0x11241
        0xdedf, // 0x112DF
        [0xdee3, 0xdeea], // 0x112E3..0x112EA
        [0xdf00, 0xdf01], // 0x11300..0x11301
        [0xdf3b, 0xdf3c], // 0x1133B..0x1133C
        0xdf40, // 0x11340
        [0xdf66, 0xdf6c], // 0x11366..0x1136C
        [0xdf70, 0xdf74], // 0x11370..0x11374
        [0xdfbb, 0xdfc0], // 0x113BB..0x113C0
        0xdfce, // 0x113CE
        0xdfd0, // 0x113D0
        0xdfd2, // 0x113D2
        [0xdfe1, 0xdfe2], // 0x113E1..0x113E2
    ],
    0xd805: [
        [0xdc38, 0xdc3f], // 0x11438..0x1143F
        [0xdc42, 0xdc44], // 0x11442..0x11444
        0xdc46, // 0x11446
        0xdc5e, // 0x1145E
        [0xdcb3, 0xdcb8], // 0x114B3..0x114B8
        0xdcba, // 0x114BA
        [0xdcbf, 0xdcc0], // 0x114BF..0x114C0
        [0xdcc2, 0xdcc3], // 0x114C2..0x114C3
        [0xddb2, 0xddb5], // 0x115B2..0x115B5
        [0xddbc, 0xddbd], // 0x115BC..0x115BD
        [0xddbf, 0xddc0], // 0x115BF..0x115C0
        [0xdddc, 0xdddd], // 0x115DC..0x115DD
        [0xde33, 0xde3a], // 0x11633..0x1163A
        0xde3d, // 0x1163D
        [0xde3f, 0xde40], // 0x1163F..0x11640
        0xdeab, // 0x116AB
        0xdead, // 0x116AD
        [0xdeb0, 0xdeb5], // 0x116B0..0x116B5
        0xdeb7, // 0x116B7
        0xdf1d, // 0x1171D
        0xdf1f, // 0x1171F
        [0xdf22, 0xdf25], // 0x11722..0x11725
        [0xdf27, 0xdf2b], // 0x11727..0x1172B
    ],
    0xd806: [
        [0xdc2f, 0xdc37], // 0x1182F..0x11837
        [0xdc39, 0xdc3a], // 0x11839..0x1183A
        [0xdd3b, 0xdd3c], // 0x1193B..0x1193C
        0xdd3e, // 0x1193E
        0xdd43, // 0x11943
        [0xddd4, 0xddd7], // 0x119D4..0x119D7
        [0xddda, 0xdddb], // 0x119DA..0x119DB
        0xdde0, // 0x119E0
        [0xde01, 0xde0a], // 0x11A01..0x11A0A
        [0xde33, 0xde38], // 0x11A33..0x11A38
        [0xde3b, 0xde3e], // 0x11A3B..0x11A3E
        0xde47, // 0x11A47
        [0xde51, 0xde56], // 0x11A51..0x11A56
        [0xde59, 0xde5b], // 0x11A59..0x11A5B
        [0xde8a, 0xde96], // 0x11A8A..0x11A96
        [0xde98, 0xde99], // 0x11A98..0x11A99
    ],
    0xd807: [
        [0xdc30, 0xdc36], // 0x11C30..0x11C36
        [0xdc38, 0xdc3d], // 0x11C38..0x11C3D
        0xdc3f, // 0x11C3F
        [0xdc92, 0xdca7], // 0x11C92..0x11CA7
        [0xdcaa, 0xdcb0], // 0x11CAA..0x11CB0
        [0xdcb2, 0xdcb3], // 0x11CB2..0x11CB3
        [0xdcb5, 0xdcb6], // 0x11CB5..0x11CB6
        [0xdd31, 0xdd36], // 0x11D31..0x11D36
        0xdd3a, // 0x11D3A
        [0xdd3c, 0xdd3d], // 0x11D3C..0x11D3D
        [0xdd3f, 0xdd45], // 0x11D3F..0x11D45
        0xdd47, // 0x11D47
        [0xdd90, 0xdd91], // 0x11D90..0x11D91
        0xdd95, // 0x11D95
        0xdd97, // 0x11D97
        [0xdef3, 0xdef4], // 0x11EF3..0x11EF4
        [0xdf00, 0xdf01], // 0x11F00..0x11F01
        [0xdf36, 0xdf3a], // 0x11F36..0x11F3A
        0xdf40, // 0x11F40
        0xdf42, // 0x11F42
        0xdf5a, // 0x11F5A
    ],
    0xd80d: [
        0xdc40, // 0x13440
        [0xdc47, 0xdc55], // 0x13447..0x13455
    ],
    0xd818: [
        [0xdd1e, 0xdd29], // 0x1611E..0x16129
        [0xdd2d, 0xdd2f], // 0x1612D..0x1612F
    ],
    0xd81a: [
        [0xdef0, 0xdef4], // 0x16AF0..0x16AF4
        [0xdf30, 0xdf36], // 0x16B30..0x16B36
    ],
    0xd81b: [
        0xdf4f, // 0x16F4F
        [0xdf8f, 0xdf92], // 0x16F8F..0x16F92
        0xdfe4, // 0x16FE4
    ],
    0xd82f: [
        [0xdc9d, 0xdc9e], // 0x1BC9D..0x1BC9E
    ],
    0xd833: [
        [0xdf00, 0xdf2d], // 0x1CF00..0x1CF2D
        [0xdf30, 0xdf46], // 0x1CF30..0x1CF46
    ],
    0xd834: [
        [0xdd67, 0xdd69], // 0x1D167..0x1D169
        [0xdd7b, 0xdd82], // 0x1D17B..0x1D182
        [0xdd85, 0xdd8b], // 0x1D185..0x1D18B
        [0xddaa, 0xddad], // 0x1D1AA..0x1D1AD
        [0xde42, 0xde44], // 0x1D242..0x1D244
    ],
    0xd836: [
        [0xde00, 0xde36], // 0x1DA00..0x1DA36
        [0xde3b, 0xde6c], // 0x1DA3B..0x1DA6C
        0xde75, // 0x1DA75
        0xde84, // 0x1DA84
        [0xde9b, 0xde9f], // 0x1DA9B..0x1DA9F
        [0xdea1, 0xdeaf], // 0x1DAA1..0x1DAAF
    ],
    0xd838: [
        [0xdc00, 0xdc06], // 0x1E000..0x1E006
        [0xdc08, 0xdc18], // 0x1E008..0x1E018
        [0xdc1b, 0xdc21], // 0x1E01B..0x1E021
        [0xdc23, 0xdc24], // 0x1E023..0x1E024
        [0xdc26, 0xdc2a], // 0x1E026..0x1E02A
        0xdc8f, // 0x1E08F
        [0xdd30, 0xdd36], // 0x1E130..0x1E136
        0xdeae, // 0x1E2AE
        [0xdeec, 0xdeef], // 0x1E2EC..0x1E2EF
    ],
    0xd839: [
        [0xdcec, 0xdcef], // 0x1E4EC..0x1E4EF
        [0xddee, 0xddef], // 0x1E5EE..0x1E5EF
    ],
    0xd83a: [
        [0xdcd0, 0xdcd6], // 0x1E8D0..0x1E8D6
        [0xdd44, 0xdd4a], // 0x1E944..0x1E94A
    ],
    0xdb40: [
        [0xdd00, 0xddef], // 0xE0100..0xE01EF
    ],
};

export const unicodeMc: UnicodeRangeTable = [
    0x0903,
    0x093b,
    [0x093e, 0x0940],
    [0x0949, 0x094c],
    [0x094e, 0x094f],
    [0x0982, 0x0983],
    [0x09be, 0x09c0],
    [0x09c7, 0x09c8],
    [0x09cb, 0x09cc],
    0x09d7,
    0x0a03,
    [0x0a3e, 0x0a40],
    0x0a83,
    [0x0abe, 0x0ac0],
    0x0ac9,
    [0x0acb, 0x0acc],
    [0x0b02, 0x0b03],
    0x0b3e,
    0x0b40,
    [0x0b47, 0x0b48],
    [0x0b4b, 0x0b4c],
    0x0b57,
    [0x0bbe, 0x0bbf],
    [0x0bc1, 0x0bc2],
    [0x0bc6, 0x0bc8],
    [0x0bca, 0x0bcc],
    0x0bd7,
    [0x0c01, 0x0c03],
    [0x0c41, 0x0c44],
    [0x0c82, 0x0c83],
    0x0cbe,
    [0x0cc0, 0x0cc4],
    [0x0cc7, 0x0cc8],
    [0x0cca, 0x0ccb],
    [0x0cd5, 0x0cd6],
    0x0cf3,
    [0x0d02, 0x0d03],
    [0x0d3e, 0x0d40],
    [0x0d46, 0x0d48],
    [0x0d4a, 0x0d4c],
    0x0d57,
    [0x0d82, 0x0d83],
    [0x0dcf, 0x0dd1],
    [0x0dd8, 0x0ddf],
    [0x0df2, 0x0df3],
    [0x0f3e, 0x0f3f],
    0x0f7f,
    [0x102b, 0x102c],
    0x1031,
    0x1038,
    [0x103b, 0x103c],
    [0x1056, 0x1057],
    [0x1062, 0x1064],
    [0x1067, 0x106d],
    [0x1083, 0x1084],
    [0x1087, 0x108c],
    0x108f,
    [0x109a, 0x109c],
    0x1715,
    0x1734,
    0x17b6,
    [0x17be, 0x17c5],
    [0x17c7, 0x17c8],
    [0x1923, 0x1926],
    [0x1929, 0x192b],
    [0x1930, 0x1931],
    [0x1933, 0x1938],
    [0x1a19, 0x1a1a],
    0x1a55,
    0x1a57,
    0x1a61,
    [0x1a63, 0x1a64],
    [0x1a6d, 0x1a72],
    0x1b04,
    0x1b35,
    0x1b3b,
    [0x1b3d, 0x1b41],
    [0x1b43, 0x1b44],
    0x1b82,
    0x1ba1,
    [0x1ba6, 0x1ba7],
    0x1baa,
    0x1be7,
    [0x1bea, 0x1bec],
    0x1bee,
    [0x1bf2, 0x1bf3],
    [0x1c24, 0x1c2b],
    [0x1c34, 0x1c35],
    0x1ce1,
    0x1cf7,
    [0x302e, 0x302f],
    [0xa823, 0xa824],
    0xa827,
    [0xa880, 0xa881],
    [0xa8b4, 0xa8c3],
    [0xa952, 0xa953],
    0xa983,
    [0xa9b4, 0xa9b5],
    [0xa9ba, 0xa9bb],
    [0xa9be, 0xa9c0],
    [0xaa2f, 0xaa30],
    [0xaa33, 0xaa34],
    0xaa4d,
    0xaa7b,
    0xaa7d,
    0xaaeb,
    [0xaaee, 0xaaef],
    0xaaf5,
    [0xabe3, 0xabe4],
    [0xabe6, 0xabe7],
    [0xabe9, 0xabea],
    0xabec,
    0x11000,
    0x11002,
    0x11082,
    [0x110b0, 0x110b2],
    [0x110b7, 0x110b8],
    0x1112c,
    [0x11145, 0x11146],
    0x11182,
    [0x111b3, 0x111b5],
    [0x111bf, 0x111c0],
    0x111ce,
    [0x1122c, 0x1122e],
    [0x11232, 0x11233],
    0x11235,
    [0x112e0, 0x112e2],
    [0x11302, 0x11303],
    [0x1133e, 0x1133f],
    [0x11341, 0x11344],
    [0x11347, 0x11348],
    [0x1134b, 0x1134d],
    0x11357,
    [0x11362, 0x11363],
    [0x113b8, 0x113ba],
    0x113c2,
    0x113c5,
    [0x113c7, 0x113ca],
    [0x113cc, 0x113cd],
    0x113cf,
    [0x11435, 0x11437],
    [0x11440, 0x11441],
    0x11445,
    [0x114b0, 0x114b2],
    0x114b9,
    [0x114bb, 0x114be],
    0x114c1,
    [0x115af, 0x115b1],
    [0x115b8, 0x115bb],
    0x115be,
    [0x11630, 0x11632],
    [0x1163b, 0x1163c],
    0x1163e,
    0x116ac,
    [0x116ae, 0x116af],
    0x116b6,
    0x1171e,
    [0x11720, 0x11721],
    0x11726,
    [0x1182c, 0x1182e],
    0x11838,
    [0x11930, 0x11935],
    [0x11937, 0x11938],
    0x1193d,
    0x11940,
    0x11942,
    [0x119d1, 0x119d3],
    [0x119dc, 0x119df],
    0x119e4,
    0x11a39,
    [0x11a57, 0x11a58],
    0x11a97,
    0x11c2f,
    0x11c3e,
    0x11ca9,
    0x11cb1,
    0x11cb4,
    [0x11d8a, 0x11d8e],
    [0x11d93, 0x11d94],
    0x11d96,
    [0x11ef5, 0x11ef6],
    0x11f03,
    [0x11f34, 0x11f35],
    [0x11f3e, 0x11f3f],
    0x11f41,
    [0x1612a, 0x1612c],
    [0x16f51, 0x16f87],
    [0x16ff0, 0x16ff1],
    [0x1d165, 0x1d166],
    [0x1d16d, 0x1d172],
];

export const unicodeMcSurrogate: UnicodeSurrogateRangeTable = {
    0xd804: [
        0xdc00, // 0x11000
        0xdc02, // 0x11002
        0xdc82, // 0x11082
        [0xdcb0, 0xdcb2], // 0x110B0..0x110B2
        [0xdcb7, 0xdcb8], // 0x110B7..0x110B8
        0xdd2c, // 0x1112C
        [0xdd45, 0xdd46], // 0x11145..0x11146
        0xdd82, // 0x11182
        [0xddb3, 0xddb5], // 0x111B3..0x111B5
        [0xddbf, 0xddc0], // 0x111BF..0x111C0
        0xddce, // 0x111CE
        [0xde2c, 0xde2e], // 0x1122C..0x1122E
        [0xde32, 0xde33], // 0x11232..0x11233
        0xde35, // 0x11235
        [0xdee0, 0xdee2], // 0x112E0..0x112E2
        [0xdf02, 0xdf03], // 0x11302..0x11303
        [0xdf3e, 0xdf3f], // 0x1133E..0x1133F
        [0xdf41, 0xdf44], // 0x11341..0x11344
        [0xdf47, 0xdf48], // 0x11347..0x11348
        [0xdf4b, 0xdf4d], // 0x1134B..0x1134D
        0xdf57, // 0x11357
        [0xdf62, 0xdf63], // 0x11362..0x11363
        [0xdfb8, 0xdfba], // 0x113B8..0x113BA
        0xdfc2, // 0x113C2
        0xdfc5, // 0x113C5
        [0xdfc7, 0xdfca], // 0x113C7..0x113CA
        [0xdfcc, 0xdfcd], // 0x113CC..0x113CD
        0xdfcf, // 0x113CF
    ],
    0xd805: [
        [0xdc35, 0xdc37], // 0x11435..0x11437
        [0xdc40, 0xdc41], // 0x11440..0x11441
        0xdc45, // 0x11445
        [0xdcb0, 0xdcb2], // 0x114B0..0x114B2
        0xdcb9, // 0x114B9
        [0xdcbb, 0xdcbe], // 0x114BB..0x114BE
        0xdcc1, // 0x114C1
        [0xddaf, 0xddb1], // 0x115AF..0x115B1
        [0xddb8, 0xddbb], // 0x115B8..0x115BB
        0xddbe, // 0x115BE
        [0xde30, 0xde32], // 0x11630..0x11632
        [0xde3b, 0xde3c], // 0x1163B..0x1163C
        0xde3e, // 0x1163E
        0xdeac, // 0x116AC
        [0xdeae, 0xdeaf], // 0x116AE..0x116AF
        0xdeb6, // 0x116B6
        0xdf1e, // 0x1171E
        [0xdf20, 0xdf21], // 0x11720..0x11721
        0xdf26, // 0x11726
    ],
    0xd806: [
        [0xdc2c, 0xdc2e], // 0x1182C..0x1182E
        0xdc38, // 0x11838
        [0xdd30, 0xdd35], // 0x11930..0x11935
        [0xdd37, 0xdd38], // 0x11937..0x11938
        0xdd3d, // 0x1193D
        0xdd40, // 0x11940
        0xdd42, // 0x11942
        [0xddd1, 0xddd3], // 0x119D1..0x119D3
        [0xdddc, 0xdddf], // 0x119DC..0x119DF
        0xdde4, // 0x119E4
        0xde39, // 0x11A39
        [0xde57, 0xde58], // 0x11A57..0x11A58
        0xde97, // 0x11A97
    ],
    0xd807: [
        0xdc2f, // 0x11C2F
        0xdc3e, // 0x11C3E
        0xdca9, // 0x11CA9
        0xdcb1, // 0x11CB1
        0xdcb4, // 0x11CB4
        [0xdd8a, 0xdd8e], // 0x11D8A..0x11D8E
        [0xdd93, 0xdd94], // 0x11D93..0x11D94
        0xdd96, // 0x11D96
        [0xdef5, 0xdef6], // 0x11EF5..0x11EF6
        0xdf03, // 0x11F03
        [0xdf34, 0xdf35], // 0x11F34..0x11F35
        [0xdf3e, 0xdf3f], // 0x11F3E..0x11F3F
        0xdf41, // 0x11F41
    ],
    0xd818: [
        [0xdd2a, 0xdd2c], // 0x1612A..0x1612C
    ],
    0xd81b: [
        [0xdf51, 0xdf87], // 0x16F51..0x16F87
        [0xdff0, 0xdff1], // 0x16FF0..0x16FF1
    ],
    0xd834: [
        [0xdd65, 0xdd66], // 0x1D165..0x1D166
        [0xdd6d, 0xdd72], // 0x1D16D..0x1D172
    ],
};

export const unicodeNd: UnicodeRangeTable = [
    [0x0030, 0x0039],
    [0x0660, 0x0669],
    [0x06f0, 0x06f9],
    [0x07c0, 0x07c9],
    [0x0966, 0x096f],
    [0x09e6, 0x09ef],
    [0x0a66, 0x0a6f],
    [0x0ae6, 0x0aef],
    [0x0b66, 0x0b6f],
    [0x0be6, 0x0bef],
    [0x0c66, 0x0c6f],
    [0x0ce6, 0x0cef],
    [0x0d66, 0x0d6f],
    [0x0de6, 0x0def],
    [0x0e50, 0x0e59],
    [0x0ed0, 0x0ed9],
    [0x0f20, 0x0f29],
    [0x1040, 0x1049],
    [0x1090, 0x1099],
    [0x17e0, 0x17e9],
    [0x1810, 0x1819],
    [0x1946, 0x194f],
    [0x19d0, 0x19d9],
    [0x1a80, 0x1a89],
    [0x1a90, 0x1a99],
    [0x1b50, 0x1b59],
    [0x1bb0, 0x1bb9],
    [0x1c40, 0x1c49],
    [0x1c50, 0x1c59],
    [0xa620, 0xa629],
    [0xa8d0, 0xa8d9],
    [0xa900, 0xa909],
    [0xa9d0, 0xa9d9],
    [0xa9f0, 0xa9f9],
    [0xaa50, 0xaa59],
    [0xabf0, 0xabf9],
    [0xff10, 0xff19],
    [0x104a0, 0x104a9],
    [0x10d30, 0x10d39],
    [0x10d40, 0x10d49],
    [0x11066, 0x1106f],
    [0x110f0, 0x110f9],
    [0x11136, 0x1113f],
    [0x111d0, 0x111d9],
    [0x112f0, 0x112f9],
    [0x11450, 0x11459],
    [0x114d0, 0x114d9],
    [0x11650, 0x11659],
    [0x116c0, 0x116c9],
    [0x116d0, 0x116e3],
    [0x11730, 0x11739],
    [0x118e0, 0x118e9],
    [0x11950, 0x11959],
    [0x11bf0, 0x11bf9],
    [0x11c50, 0x11c59],
    [0x11d50, 0x11d59],
    [0x11da0, 0x11da9],
    [0x11f50, 0x11f59],
    [0x16130, 0x16139],
    [0x16a60, 0x16a69],
    [0x16ac0, 0x16ac9],
    [0x16b50, 0x16b59],
    [0x16d70, 0x16d79],
    [0x1ccf0, 0x1ccf9],
    [0x1d7ce, 0x1d7ff],
    [0x1e140, 0x1e149],
    [0x1e2f0, 0x1e2f9],
    [0x1e4f0, 0x1e4f9],
    [0x1e5f1, 0x1e5fa],
    [0x1e950, 0x1e959],
    [0x1fbf0, 0x1fbf9],
];

export const unicodeNdSurrogate: UnicodeSurrogateRangeTable = {
    0xd801: [
        [0xdca0, 0xdca9], // 0x104A0..0x104A9
    ],
    0xd803: [
        [0xdd30, 0xdd39], // 0x10D30..0x10D39
        [0xdd40, 0xdd49], // 0x10D40..0x10D49
    ],
    0xd804: [
        [0xdc66, 0xdc6f], // 0x11066..0x1106F
        [0xdcf0, 0xdcf9], // 0x110F0..0x110F9
        [0xdd36, 0xdd3f], // 0x11136..0x1113F
        [0xddd0, 0xddd9], // 0x111D0..0x111D9
        [0xdef0, 0xdef9], // 0x112F0..0x112F9
    ],
    0xd805: [
        [0xdc50, 0xdc59], // 0x11450..0x11459
        [0xdcd0, 0xdcd9], // 0x114D0..0x114D9
        [0xde50, 0xde59], // 0x11650..0x11659
        [0xdec0, 0xdec9], // 0x116C0..0x116C9
        [0xded0, 0xdee3], // 0x116D0..0x116E3
        [0xdf30, 0xdf39], // 0x11730..0x11739
    ],
    0xd806: [
        [0xdce0, 0xdce9], // 0x118E0..0x118E9
        [0xdd50, 0xdd59], // 0x11950..0x11959
        [0xdff0, 0xdff9], // 0x11BF0..0x11BF9
    ],
    0xd807: [
        [0xdc50, 0xdc59], // 0x11C50..0x11C59
        [0xdd50, 0xdd59], // 0x11D50..0x11D59
        [0xdda0, 0xdda9], // 0x11DA0..0x11DA9
        [0xdf50, 0xdf59], // 0x11F50..0x11F59
    ],
    0xd818: [
        [0xdd30, 0xdd39], // 0x16130..0x16139
    ],
    0xd81a: [
        [0xde60, 0xde69], // 0x16A60..0x16A69
        [0xdec0, 0xdec9], // 0x16AC0..0x16AC9
        [0xdf50, 0xdf59], // 0x16B50..0x16B59
    ],
    0xd81b: [
        [0xdd70, 0xdd79], // 0x16D70..0x16D79
    ],
    0xd833: [
        [0xdcf0, 0xdcf9], // 0x1CCF0..0x1CCF9
    ],
    0xd835: [
        [0xdfce, 0xdfff], // 0x1D7CE..0x1D7FF
    ],
    0xd838: [
        [0xdd40, 0xdd49], // 0x1E140..0x1E149
        [0xdef0, 0xdef9], // 0x1E2F0..0x1E2F9
    ],
    0xd839: [
        [0xdcf0, 0xdcf9], // 0x1E4F0..0x1E4F9
        [0xddf1, 0xddfa], // 0x1E5F1..0x1E5FA
    ],
    0xd83a: [
        [0xdd50, 0xdd59], // 0x1E950..0x1E959
    ],
    0xd83e: [
        [0xdff0, 0xdff9], // 0x1FBF0..0x1FBF9
    ],
};

export const unicodePc: UnicodeRangeTable = [
    0x005f,
    [0x203f, 0x2040],
    0x2054,
    [0xfe33, 0xfe34],
    [0xfe4d, 0xfe4f],
    0xff3f,
];
